import { useRmCertification } from "../helpers/useRmCertification";

import { useContext, useEffect, useMemo, useState } from 'react';
import 'dayjs/locale/en-gb';
import { collection, orderBy, query, limit, DocumentData, onSnapshot, DocumentReference, doc, deleteDoc, where, getDocs, QueryDocumentSnapshot, getDoc, writeBatch, Timestamp } from 'firebase/firestore';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { AppConfigContext, ConfigContext, GlobalDataContext, MyUserDataContext } from '../contexts';
import { httpsCallable } from 'firebase/functions';
import { Group, Modal, TextInput, Text, Button, Space, Title, SimpleGrid, Grid, Checkbox, Box, Stack, Alert, Image, ActionIcon, NumberInput, NumberFormatter, Accordion, ThemeIcon, Menu, Card, Tooltip, Paper, Badge, Divider, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';
import { Action, ActionType, AddOrderGenevaResponseRequest, BaseResult, CreateContractLink, Customer, ALWAYS_SELECTED_PAGES, DeleteOrderGenevaResponseRequest, KYC, Order, SubscriptionType, OrderRefreshRequest, UploadFileResult, UpdateOrderRequest, OrderStatusCode, CustomClaims, CustomFileWithPath, SendOrderSMSRequest, DocType, ItemInfoEditedObj, Fund, GenericProduct, OrdersPath, GeneralOrderRequest, RejectionFormValues, KYCState, KYCStatusCode, AgentNotficationFormValues, InvoicePaymentConfirmation, contractLinksCollection, UpdateOrderAmountRequest, AddOrderResult, CutoffSpec, CustomerFundData } from '../types';
import { IconAlertCircle, IconEdit, IconPhone, IconSchool, IconShoppingCart, IconBuildingBank, IconScript, IconCreditCard, IconX, IconCheck, IconMoneybag, IconGalaxy, IconTrash, IconRefresh } from '@tabler/icons-react';
import { FirebaseError } from 'firebase/app';
import { FilesList } from './files';
import GeneratePDFModal from './generate_pdf_modal';
import { ordersPath } from '../helpers/orderFilesPath';
import { getAddressDetailsEnglish } from '../helpers/addressHelpers';
import { getCustomerFromPaciPersonalData, isCorporateEmail } from '../helpers/common';
import { CustomerKYC } from '../routes/customers/customer_kyc';
import { modals, openConfirmModal } from '@mantine/modals';
import { updateDoc } from 'firebase/firestore';
import { FileRejection, FileWithPath } from '@mantine/dropzone';
import BankAccountInfo from '../routes/BankAccountInfo';
import { generateIBANFromKFHAccountNo, getKFHAccountNo } from '../utils';
import { isValidIBAN } from 'ibantools';
import { deleteObject, getDownloadURL, getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import { getFolderTagStatus, type FolderTagStatus } from '../helpers/areAllFolderFilesTagged';
import { notifications, showNotification } from '@mantine/notifications';
import { CustomInfoCard } from '../routes/customers/CustomInfoCard';
import { map } from 'lodash';
import EditableInfoCard from '../routes/customers/EditableInfoCard';
import { calc } from '../helpers/orderHelpers';
import ChangeRmModalContent from './change_rm_modal';
import { useFirestore, useFunctions } from '../helpers/firebaseContext';
import useFirestoreDoc from '../helpers/useFirestoreDoc';
import useApprovals from '../helpers/useApprovals';
import { uploadToStorage } from '../helpers/uploadToStorage';
import { UploadBox } from './upload_box';
import { MessagesSent, refreshWhatsappTemplates } from './send_sms_modal';
// import useFirestoreDocData from '../helpers/useFirestoreDocData';
import CustomRejectionModal from './custom_rejection_modal';
import CustomProductComment from './custom_product_comment';
import CustomProductTimeline from './custom_product_timeline';
import { IbanInfoCard } from './iban_info_card';
import { RmInformationCard } from './rm_information_card';

type GenevaResponseKey = keyof NonNullable<Order["geneva_responses"]>;
type GenevaResponsePayload = Record<string, string | undefined> & {
    status?: string;
    code?: string;
    status_message?: string;
};

const GENEVA_RESPONSE_FIELDS: Record<SubscriptionType, Array<{ key: GenevaResponseKey; label: string }>> = {
    subscription: [
        { key: "initial_subscription_journal_transaction", label: "Initial Subscription JT" },
        { key: "reversal_subscription_journal_transaction", label: "Reversal Subscription JT" },
        { key: "subscription_journal_transaction", label: "Subscription JT" },
        { key: "gwi_order", label: "GWI Order" },
    ],
    redemption: [
        { key: "redemption_journal_transaction", label: "Redemption JT" },
        { key: "gwi_order", label: "GWI Order" },
    ],
};

const EXPECTED_NAV_UTC_HOUR = 3;

const hasExpectedNavDateOverride = (order: Order): boolean =>
    order.updated_data?.some((entry) =>
        entry?.updated_fields?.some((updatedField) =>
            Object.prototype.hasOwnProperty.call(updatedField, "expected_nav_date")
        )
    ) ?? false;

const formatExpectedNavDate = (timestamp?: Timestamp): string | undefined =>
    timestamp?.toDate().toLocaleDateString("en-GB", {
        timeZone: "Asia/Kuwait",
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

const normalizeExpectedNavDate = (timestamp: Timestamp | null): Timestamp | null => {
    if (!timestamp) {
        return null;
    }

    const selectedDate = timestamp.toDate();
    return Timestamp.fromDate(new Date(Date.UTC(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        EXPECTED_NAV_UTC_HOUR,
        0,
        0,
        0,
    )));
};


const EditUnits = ({ orderRef, startingUnits = 0 }: { orderRef: DocumentReference, startingUnits?: number }) => {

    const [updating, setUpdating] = useState(false);
    const [units, setUnits] = useState(startingUnits);

    const userData = useContext(MyUserDataContext);

    console.log("userData in EditUnits", userData);


    return <>
        <NumberInput label="Number of units" data-autofocus value={units} onChange={(v) => setUnits(Number(v))} />

        <Button loading={updating} fullWidth onClick={async () => {
            setUpdating(true);

            //change number of units in firestore
            console.log("userData", userData);
            await updateDoc(orderRef, { units: units, unitsUpdatedBy: userData.user?.email || "No email" });

            setUpdating(false);
            modals.closeAll();

        }} mt="md">
            Submit
        </Button>

    </>


}

export interface OrderInfoProps {
    order: Order,
    customerRef: DocumentReference,
    orderRef: DocumentReference,
    orderDoc?: QueryDocumentSnapshot<Order>
    updatedOrderData?: any
}

//create CustomerInfo component
export const OrderInfo = ({ orderDoc, order, customerRef, orderRef }: OrderInfoProps) => {
    const { id } = useParams();
    const storage = getStorage();
    const globalDataContext = useContext(GlobalDataContext);

    // const customerData =
    //     (order?.paciData ? { ...getCustomerFromPaciPersonalData(order?.paciData) } : (order.customerObj)) as (Customer & KYC)

    const [updatedOrderData, setUpdatedOrderData] = useState<ItemInfoEditedObj<Order>>({});


    const paciData = getCustomerFromPaciPersonalData(order?.paciData);

    const userData = useContext(MyUserDataContext);
    const appConfigContext = useContext(AppConfigContext);
    const config = useContext(ConfigContext);
    let userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};
    const { certified: currentRmCertified } = useRmCertification(userData.user?.email);
    const expectedNavDateOverridden = hasExpectedNavDateOverride(order);

    console.log("The user data in OrderInfo is", userData);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [links, setLinks] = useState([] as any[]);
    const [SMSDocID, setSMSDocID] = useState<string>();

    const navigate = useNavigate();

    const db = useFirestore();

    //make pending state
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pending, setPending] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [openAccordions, setOpenAccordions] = useState<string[]>(["order"])

    const [msg, setMsg] = useState(null as any);
    const [isError, setIsError] = useState(false);

    const [useWhatsapp, setUseWhatsapp] = useState(false);
    const [outdatedKyc, setOutdatedKyc] = useState(false);
    const [generatePDFOpen, setGeneratePDFOpen] = useState(false);
    const [generateFilledPDFOpen, setGenerateFilledPDFOpen] = useState(false);
    const [allFilesTagged, setAllFilesTagged] = useState<boolean>(true);
    const [orderFileTagStatus, setOrderFileTagStatus] = useState<FolderTagStatus>({
        allFilesTagged: true,
        checkedFiles: 0,
        untaggedFiles: [],
    });
    const [isRejectingOrder, setIsRejectingOrder] = useState<boolean>(true);
    const [changeRmOpen, setChangeRmOpen] = useState(false);
    const [changeReferredByRmOpen, setChangeReferredByRmOpen] = useState(false);
    const [refetchAgreement, setRefetchAgreement] = useState(false)
    const [finalSignedAgreementLoading, setFinalSignedAgreementLoading] = useState(false);
    const [emptyOrderFilePath, setEmptyOrderFilePath] = useState<OrdersPath[]>([]);

    const [metaTypes, setMetaTypes] = useState<DocType[]>([]);  //this is for CustomerKYC to set the metatypes of files that exist on the KYC.  That way, we can populate the Generate PDF form properly.


    const [draftActionLoading, setDraftActionLoading] = useState(false);

    const [kycData, setKycData] = useState<KYC | null>(null);
    // const [kycTags, setKycTags] = useState<Tag>();
    const [latestFundData, setLatestFundData] = useState<Fund | null>(null);
    // Customer's held units in this fund (customers/{id}/fund_data/{fundId}.eunits); null until loaded.
    const [customerFundUnits, setCustomerFundUnits] = useState<number | null>(null);


    const [forceRefreshFiles, setForceRefreshFiles] = useState<number | null>();

    const [refreshing, setRefreshing] = useState(false);
    const [deletingGenevaKey, setDeletingGenevaKey] = useState<GenevaResponseKey | null>(null);
    const [addingGenevaKey, setAddingGenevaKey] = useState<GenevaResponseKey | null>(null);

    const { actions, actionsAfterRejections } = useApprovals(orderRef);
    const [orderPaymentConfirmations, setOrderPaymentConfirmations] = useState<InvoicePaymentConfirmation[]>([]);



    const functions = useFunctions();
    functions.region = "europe-west1";

    const orderAction = httpsCallable<Action, BaseResult>(functions, 'orderAction');
    const kycAction = httpsCallable<Action, BaseResult>(functions, "kycAction");
    // DocuSign signature verification (operations of the client's segment, or CR/admin)
    const createContractLink = httpsCallable<CreateContractLink, BaseResult>(functions, "createContractLink");
    const contractKYCUpdate = httpsCallable<RejectionFormValues, BaseResult>(functions, "contractKYCUpdate");
    const [signatureRejectComments, setSignatureRejectComments] = useState("");
    const [signatureActionLoading, setSignatureActionLoading] = useState(false);

    //get customerRef from order
    useEffect(() => {
        if (!order) return;
        let kycUnsubscriber = () => { };

        // handle multiple vs single payment confirmations
        let paymentConfirmations = [] as InvoicePaymentConfirmation[];
        if (order?.payment_confirmations && order?.payment_confirmations?.length > 0) {
            paymentConfirmations = order.payment_confirmations;
        } else if (order?.payment_confirmation) {
            paymentConfirmations = [order.payment_confirmation];
        }
        if (paymentConfirmations.length > 0) {
            paymentConfirmations = paymentConfirmations.map((paymentConfirmation) => {
                return {
                    ...paymentConfirmation,
                    name: undefined,
                    amountInBaseCurrency: undefined,
                    transferAmountWhenReceived: undefined,
                    currency: undefined,
                    transactionTitle: paymentConfirmation.name,
                    transferAmount: paymentConfirmation.amountInBaseCurrency ?? order.transferAmount,
                    transferCurrency: order.fund.currency,
                    fundName: order.fund.name_en,
                    clientName: order.customerObj?.name_en,
                    transactionTimestamp: undefined,
                    receivedAt: undefined,
                    transactionDate: paymentConfirmation.transactionTimestamp?.toDate().toLocaleString("en-gb") ?? paymentConfirmation.transactionDate,
                }
            })
        }

        setOrderPaymentConfirmations(paymentConfirmations);

        if (order?.kyc_id) {


            const kycStateDoc = doc(db, `customers/${customerRef?.id}/kyc`, order?.kyc_id);
            setKycLoading(true);

            kycUnsubscriber = onSnapshot(kycStateDoc, (snapshot) => {
                if (snapshot.metadata.fromCache) {
                    console.log("kycState Cached data", snapshot.data());
                } else {
                    console.log("kycState Server data", snapshot.data());
                }

                const data = { ...snapshot.data(), id: snapshot.id } as KYC;

                setKycData(data);

                //TODO : KYC Object should have a state "object"
                setKycState(data.state)
                setKycLoading(false);
            });

        }
        else {

            // const kycTagsDoc = query(collection(db , "customers"),where("id","==",order.customerRef.id));
            const kycCollection = collection(customerRef as DocumentReference, "kyc");
            let kycQuery = query(kycCollection, orderBy("created", "desc"), limit(1));
            // kycQuery = query(kycQuery, limit(1));


            kycUnsubscriber = onSnapshot(kycQuery,
                (snapshot) => {
                    if (snapshot.metadata.fromCache) {
                        console.log("Cached data kycUnsubscriber", snapshot.docs.length);
                        // return;
                    }
                    else {
                        console.log("Server data kycUnsubscriber", snapshot.docs.length);
                    }

                    if (!snapshot.empty) {
                        let data = snapshot.docs[0].data();
                        data.id = snapshot.docs[0].id;
                        setKycData(data as KYC);
                        setKycState(data.state)
                    }

                },
                (error) => {
                    console.log(error);
                })

        }
        let customerUnsubscriber = onSnapshot(customerRef as DocumentReference,
            (snapshot) => {
                if (snapshot.metadata.fromCache) {
                    console.log("Cached data", snapshot);
                    // return;
                }
                else {
                    console.log("Server data", snapshot);
                }

                if (snapshot) {
                    // setKycTags((snapshot?.data() as Customer)?.tags?.kycStatus);
                }

            },
            (error) => {
                console.log(error);
            })

        let updatedDataObj: ItemInfoEditedObj<Order> = {}
        if (order.updated_data && order.updated_data?.length) {
            const DataKeys = (map(order.updated_data!, (value) => (map(value?.updated_fields!, (innerValue) => Object.keys(innerValue)))));
            updatedDataObj = DataKeys?.flat(2).reduce((o, key) => ({ ...o, [key]: {} }), {})

            order?.updated_data!.forEach((objEntry) => {
                objEntry?.updated_fields?.forEach((updatedField) => {

                    const objKey = Object.keys(updatedField)[0] as keyof Order;
                    updatedDataObj = {
                        ...updatedDataObj, [objKey]: {
                            ...updatedDataObj[objKey],
                            currentValue: updatedField[objKey],
                            updatedOn: objEntry?.updated_on!,
                            updatedBy: objEntry?.updated_by!

                        }
                    }

                }
                )
                objEntry?.initial_value?.forEach((previousField) => {

                    const objKey = Object.keys(previousField)[0] as keyof Order;
                    updatedDataObj = {
                        ...updatedDataObj, [objKey]: {
                            ...updatedDataObj[objKey],
                            previousValue: previousField[objKey],
                            updatedOn: objEntry?.updated_on!,
                            updatedBy: objEntry?.updated_by!,
                            reason: objEntry?.reason ?? ""



                        }
                    }

                }
                )

            }
            )

            return setUpdatedOrderData(updatedDataObj)
        }

        if (order.manual && order?.type && order?.fund) {

            let files = ordersPath[order?.type as SubscriptionType][order.fund.id];

            const fundsMap = globalDataContext?.fundsMap;

            if (fundsMap) {
                const orderPath = fundsMap[order.fund.id]?.orders_path;

                if (order?.type === "subscription") {
                    files = orderPath?.subscription ?? files;
                } else if (order?.type === "redemption") {
                    files = orderPath?.redemption ?? files;
                }
            }

            if (order.voting) {
                files = files.filter((file) => file.agreementType !== 'nonvoting')
            } else {
                files = files.filter((file) => file.agreementType !== 'voting')
            }

            setEmptyOrderFilePath(files);
        }

        return () => {
            console.log("Cleaning up...")
            kycUnsubscriber();
            customerUnsubscriber();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order]);


    useEffect(() => {

        if (order.id) {
            getFolderTagStatus(`orders/${order.id}/`).then((status) => {
                setAllFilesTagged(status.allFilesTagged);
                setOrderFileTagStatus(status);
            }).catch((err) => {
                console.error("Caught error when checking for tags", err);
                setAllFilesTagged(false);
                setOrderFileTagStatus({
                    allFilesTagged: false,
                    checkedFiles: 0,
                    untaggedFiles: [],
                    error: err instanceof Error ? err.message : "Unknown storage error",
                });
            });
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [links]);



    useEffect(() => {
        if (!order) return;
        console.log("Running effect!");

        if (order.fund.id) {
            getDoc(doc(db, `funds/${order.fund.id}`)).then((result) => {
                let data = result.data() as Fund | null;
                if (data) {
                    setLatestFundData(data!);
                }
            });
            if (order.type === "redemption" && customerRef?.id) {
                getDoc(doc(db, `customers/${customerRef.id}/fund_data/${order.fund.id}`)).then((result) => {
                    setCustomerFundUnits((result.data() as CustomerFundData | undefined)?.eunits ?? 0);
                });
            }
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [order]);
    useEffect(() => {
        const getData = async () => {

            await refreshWhatsappTemplates(true, form, appConfigContext.apiUrl!, () => { }, false, () => { },
                config?.orderTemplates?.whatsappTemplate, "linkInfo.selectedWhatsappTemplate",
            )

        }
        if (useWhatsapp) { getData() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [useWhatsapp])

    // console.log(data);

    const [uploadSlipOpened, setUploadSlipOpened] = useState(false);
    const [uploadFinalSignedAgreementOpened, setUploadFinalSignedAgreementOpened] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState<any>(null);
    const [confirmDialogError, setConfirmDialogError] = useState<any>(null);
    const [clearFiles, setClearFiles] = useState<any>(false);
    const orderRefresh = httpsCallable<OrderRefreshRequest, BaseResult>(functions, 'orderRefresh');
    const deleteOrderGenevaResponse = httpsCallable<DeleteOrderGenevaResponseRequest, BaseResult>(functions, 'deleteOrderGenevaResponse');
    const addOrderGenevaResponse = httpsCallable<AddOrderGenevaResponseRequest, BaseResult>(functions, 'addOrderGenevaResponse');



    const [pendingCreateOrderAMS, setPendingCreateOrderAMS] = useState<boolean>(false);
    const [pendingPaymentRemider, setPendingPaymentRemider] = useState<boolean>(false);
    const createAMSOrder = httpsCallable<Record<string, any>, BaseResult>(functions, "createAMSOrder");
    const sendPaymentReminder = httpsCallable<{
        orders: string[]
    }, BaseResult>(functions, "sendPaymentReminder");

    // const [rejectionReasonSelections, setRejectionReasonSelections] = useState<string[]>([]);

    const form = useForm<Action>({

        initialValues: {
            comments: '',
            action: "reject",
            token: "",
            customerID: customerRef?.id,
            orderID: order?.id,
            linkInfo: {
                smsMessage: "",
                updateType: "none",
                senderID: "",
                usePACI: true,
                passportRequired: false,  //TODO: this is hardcoded for now
            }
        },
    });


    const bankAccountForm = useForm<UpdateOrderRequest>({

        initialValues: {
            iban: "",
            account: "",
            transferDate: undefined,
        },

        validate: {
            iban: (value) => {
                if (!value) return "";
                if (value.length === 0) return 'Please enter IBAN';
                if (!isValidIBAN(value)) return 'Invalid IBAN';
                return null;
            },
            account: (value, values) => {
                if (!value) {
                    if (getKFHAccountNo(values.iban ?? "")) {
                        return 'Please enter account number';
                    }
                    return null;
                }
                if (value.length === 0) return 'Please enter account number';
                if (value.length !== 12) return 'Invalid account number';
                return null;
            },
            transferDate: (value) => {
                if (!value) return "Please enter transfer date";
                return null;
            },
        },
    });

    const formatTransferDateForUpload = (date: Date) => {
        const day = `${date.getDate()}`.padStart(2, "0");
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const customerFullDataDoc = doc(db, "customers", customerRef?.id as string);

    const { loading: customerLoading, data: customerFullData } = useFirestoreDoc<Customer>(customerFullDataDoc);

    //Used onSnapshot instead of 'useFirestoreDoc' because the kycStateDoc is depending on kycData
    const [kycState, setKycState] = useState<KYCState | undefined>(undefined);
    const [kycLoading, setKycLoading] = useState<boolean>(false);
    // useEffect(() => {
    //     console.log("KYC STATE ========>>", kycData);

    //     const kycStateDoc = doc(db, `customers/${customerRef?.id}/kyc/${kycData?.id}/private`, "state");
    //     setKycLoading(true);

    //     const unsubscribe = onSnapshot(kycStateDoc, (snapshot) => {
    //         if (snapshot.metadata.fromCache) {
    //             console.log("kycState Cached data", snapshot.data());
    //         } else {
    //             console.log("kycState Server data", snapshot.data());
    //         }

    //         const data = snapshot.data();

    //         setKycState(data);
    //         console.log("KYC STATE HERE CHECK ===>>", data);
    //         setKycLoading(false);
    //     });

    //     // Cleanup function to unsubscribe when the component unmounts or dependencies change
    //     return () => {
    //         unsubscribe();
    //     };

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [kycData]);



    const orderSkipsKYC = order.skipKYC || order.customerObj?.customerType === "trust";

    useEffect(() => {
        bankAccountForm.reset()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clearFiles])


    useEffect(() => {
        if (order.created && kycData?.created) {
            let kycDate = kycData?.created?.toDate();

            kycDate.setHours(0, 0, 0, 0);
            let orderDate = order?.created?.toDate();
            orderDate?.setHours(0, 0, 0, 0);

            if (kycDate < orderDate) {
                setOpenAccordions(["order"])
                setOutdatedKyc(true)
            }
            else {
                setOpenAccordions(["kyc", "order"])
                setOutdatedKyc(false)


            }
            if (orderSkipsKYC) {
                setOpenAccordions(["order"])
            }
        }
    }, [kycData, order, orderSkipsKYC])


    const customPath = `orders/${order?.id}/documents`;
    const customFileName = `${kycData?.civilID}-${(kycData as KYC)?.name_en}-${order.fund.name_en}`;
    const agreementFileRef = ref(storage, `${customPath}/${customFileName}.pdf`);

    const [docURL, setDocURL] = useState<string | undefined>()
    useEffect(() => {


        const getFile = async () => {
            try {

                const url = await getDownloadURL(agreementFileRef); // Get the file's download URL

                console.log("getDownloadURL returned: " + url);

                setDocURL(url);
            } catch (error) {
                console.warn("Error fetching the file URL:", error);
            }
        }
        if (kycData) {

            getFile();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetchAgreement, kycData,])
    if (kycLoading || customerLoading || !customerFullData) {

        return <p>Fetching kyc status...</p>;
    }


    const customClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};

    // generatedType={"order"}


    let kycCompleted: boolean = false;
    let KycKFHRmReviewed = false;
    if (kycData?.require_selling_agent_review && [KYCStatusCode.review, KYCStatusCode.selling_agent_review].includes(kycState?.status_code as any)) {
        KycKFHRmReviewed = true;
    }
    if (kycData?.created && order.created && (kycState?.status_code === "valid" || order.manual || KycKFHRmReviewed)) {
        //compare the day and make sure the kyc date is always the same or after the order date.  Ignore the time.
        let kycDate = kycData?.created?.toDate();


        kycDate.setHours(0, 0, 0, 0);
        let orderDate = order.created?.toDate();
        orderDate.setHours(0, 0, 0, 0);

        if (kycDate >= orderDate) {
            kycCompleted = true;
        }
    }

    //Or maybe KYC was skipped?
    if (orderSkipsKYC) {
        kycCompleted = true;
    }
    const hasOrderPaymentConfirmation = !!order.payment_confirmation || !!order.payment_confirmations?.length;
    const linkedKycBlockingReason = (() => {
        if (!kycData?.id) {
            return "No linked KYC has loaded for this order.";
        }
        if (!kycState?.status_code) {
            return "The linked KYC status has not loaded yet.";
        }
        if (kycState.status_code !== KYCStatusCode.valid && !KycKFHRmReviewed && !order.manual) {
            return `Linked KYC status: ${kycState.status ?? kycState.status_code}.`;
        }
        if (kycData.created && order.created) {
            const kycDate = kycData.created.toDate();
            kycDate.setHours(0, 0, 0, 0);
            const orderDate = order.created.toDate();
            orderDate.setHours(0, 0, 0, 0);

            if (kycDate < orderDate) {
                return "The linked KYC was created before the order date.";
            }
        }

        return "The linked KYC is not complete.";
    })();
    const generatePdfDisabledReason = (() => {
        if (kycCompleted || order.manual || hasOrderPaymentConfirmation) {
            return undefined;
        }
        if (order.approvedAt) {
            if (!order.kyc_id) {
                return "This order is approved, but no KYC is linked to it.";
            }
            if (!kycData?.created) {
                return "The approved order's linked KYC has not loaded yet.";
            }

            return undefined;
        }

        return linkedKycBlockingReason;
    })();
    const generateAgreementDocumentDisabledReason = (() => {
        if (order.tags?.orderStatus?.code === OrderStatusCode.waiting_certified_rm) {
            return "Order is waiting for certified RM review.";
        }
        if (kycCompleted) {
            return undefined;
        }
        if (order.approvedAt) {
            if (!order.kyc_id) {
                return "This order is approved, but no KYC is linked to it.";
            }
            if (!kycData?.created) {
                return "The approved order's linked KYC has not loaded yet.";
            }

            return undefined;
        }

        return linkedKycBlockingReason;
    })();

    if (!order) {
        return <p>Fetching...</p>;
    }

    let isSubscription = order.type === "subscription";

    let orderStatusCode = order.tags?.orderStatus.code as OrderStatusCode;

    // Open-ended redemption asks for more units than the customer holds in fund_data. Warning only (CR), never blocks.
    // Hidden once the order reaches processing/done.
    const unitsShortfall = !isSubscription && order.fund.type === "open_ended" && !!userClaims.cr
        && ![OrderStatusCode.waiting_for_nav, OrderStatusCode.processing, OrderStatusCode.done].includes(orderStatusCode)
        && customerFundUnits !== null && order.units !== undefined
        && (order.units === 0 ? customerFundUnits <= 0 : order.units > customerFundUnits);

    let unitsEditable: boolean = !isSubscription && userData.msal !== undefined;

    if (unitsEditable) {
        //let's make sure the units aren't editable after the order has been confirmed.

        if (orderStatusCode && [OrderStatusCode.done, OrderStatusCode.processing].includes(orderStatusCode)) {
            unitsEditable = false;
        }
        if (order.units === undefined) {
            unitsEditable = false;
        }
    }

    let genevaResponsesNeedAttention = false;
    const canManageGenevaResponses = Boolean(userClaims?.admin);
    const handleDeleteGenevaResponse = async (key: GenevaResponseKey) => {
        try {
            if (!order?.id) {
                throw new Error("Missing order ID");
            }
            setDeletingGenevaKey(key);
            await deleteOrderGenevaResponse({ orderID: order.id, key });
            notifications.show({
                title: 'Geneva delete queued',
                message: 'Remote delete started. The response will clear after Geneva confirms the delete.',
                color: 'green',
            });
        } catch (error: any) {
            console.error("Failed to delete Geneva response", error);
            notifications.show({
                title: 'Failed to delete Geneva response',
                message: error?.message ?? 'Please try again.',
                color: 'red',
            });
        } finally {
            setDeletingGenevaKey(null);
        }
    };

    const confirmDeleteGenevaResponse = (key: GenevaResponseKey, label: string) => {
        openConfirmModal({
            title: 'Delete Geneva response?',
            children: (
                <Text size="sm">
                    Delete "{label}" remotely in Geneva/GWI and clear the local response after success?
                </Text>
            ),
            labels: { confirm: 'Delete in Geneva', cancel: 'Cancel' },
            confirmProps: { color: 'red' },
            onConfirm: () => handleDeleteGenevaResponse(key),
        });
    };

    const handleAddGenevaResponse = async (key: GenevaResponseKey) => {
        try {
            if (!order?.id) {
                throw new Error("Missing order ID");
            }
            setAddingGenevaKey(key);
            await addOrderGenevaResponse({ orderID: order.id, key });
            notifications.show({
                title: 'Geneva add queued',
                message: 'Add/refresh request sent to Geneva. The response will update once Geneva processes it.',
                color: 'green',
            });
        } catch (error: any) {
            console.error("Failed to add Geneva response", error);
            notifications.show({
                title: 'Failed to add Geneva response',
                message: error?.message ?? 'Please try again.',
                color: 'red',
            });
        } finally {
            setAddingGenevaKey(null);
        }
    };

    const confirmAddGenevaResponse = (key: GenevaResponseKey, label: string, hasResponse: boolean) => {
        openConfirmModal({
            title: hasResponse ? 'Refresh Geneva response?' : 'Add Geneva response?',
            children: (
                <Text size="sm">
                    {hasResponse
                        ? `Re-send "${label}" to Geneva/GWI as an InsertUpdate. Existing records will be updated in place.`
                        : `Send "${label}" to Geneva/GWI as a new InsertUpdate request?`}
                </Text>
            ),
            labels: { confirm: hasResponse ? 'Refresh in Geneva' : 'Add in Geneva', cancel: 'Cancel' },
            confirmProps: { color: 'blue' },
            onConfirm: () => handleAddGenevaResponse(key),
        });
    };
    const genevaFieldConfig = GENEVA_RESPONSE_FIELDS[order.type as SubscriptionType] ?? [];
    const genevaResponseList = genevaFieldConfig.map(({ key, label }) => {
        const response = order.geneva_responses?.[key] as GenevaResponsePayload | undefined;
        const hasResponse = !!response && Object.keys(response).length > 0;
        const status = response?.status;
        const normalizedStatus = status?.toLowerCase();
        const isSuccess = hasResponse && normalizedStatus === "success";
        const isAdding = hasResponse && normalizedStatus === "adding";
        const iconColor = !hasResponse ? "gray" : isSuccess ? "teal" : isAdding ? "yellow" : "red";
        const tooltipLines: JSX.Element[] = [];
        if (hasResponse) {
            tooltipLines.push(<Text key="status" size="xs">Status: {status ?? "Unknown"}</Text>);
            if (response?.code) {
                tooltipLines.push(<Text key="code" size="xs">Code: {response.code}</Text>);
            }
            if (response?.status_message) {
                tooltipLines.push(<Text key="message" size="xs">Message: {response.status_message}</Text>);
            }
            if (tooltipLines.length === 1 && status === undefined) {
                tooltipLines.push(<Text key="no-details" size="xs" c="dimmed">No additional details.</Text>);
            }
        }
        if (order.geneva_responses && (!hasResponse || !isSuccess)) {
            genevaResponsesNeedAttention = true;
        }
        const tooltipContent = hasResponse ? (
            <Stack gap={2}>
                {tooltipLines}
            </Stack>
        ) : (
            <Text size="xs">No response recorded yet.</Text>
        );
        const iconNode = (
            <Tooltip label={tooltipContent} withArrow multiline>
                <ThemeIcon radius="xl" size="sm" color={iconColor}>
                    {isSuccess ? <IconCheck size={12} /> : isAdding ? <IconAlertCircle size={12} /> : <IconX size={12} />}
                </ThemeIcon>
            </Tooltip>
        );
        const isAddingThisKey = addingGenevaKey === key;
        const isDeletingThisKey = deletingGenevaKey === key;
        const isBusyThisKey = isAddingThisKey || isDeletingThisKey;

        const addNode = canManageGenevaResponses ? (
            <Tooltip label={hasResponse ? "Refresh in Geneva (InsertUpdate)" : "Add in Geneva (InsertUpdate)"} withArrow>
                <ActionIcon
                    variant="subtle"
                    color="blue"
                    size="sm"
                    loading={isAddingThisKey}
                    disabled={isBusyThisKey && !isAddingThisKey}
                    onClick={() => confirmAddGenevaResponse(key, label, hasResponse)}
                    aria-label={hasResponse ? "Refresh Geneva response" : "Add Geneva response"}
                >
                    <IconRefresh size={12} />
                </ActionIcon>
            </Tooltip>
        ) : null;

        const deleteNode = canManageGenevaResponses && hasResponse ? (
            <Tooltip label="Delete in Geneva" withArrow>
                <ActionIcon
                    variant="subtle"
                    color="red"
                    size="sm"
                    loading={isDeletingThisKey}
                    disabled={isBusyThisKey && !isDeletingThisKey}
                    onClick={() => confirmDeleteGenevaResponse(key, label)}
                    aria-label="Delete Geneva response"
                >
                    <IconTrash size={12} />
                </ActionIcon>
            </Tooltip>
        ) : null;

        return {
            label,
            value: (addNode || deleteNode) ? (
                <Group gap="xs" justify="flex-end">
                    {iconNode}
                    {addNode}
                    {deleteNode}
                </Group>
            ) : iconNode,
        };
    });
    const shouldShowGenevaResponseCard = Boolean(order.geneva_responses && genevaFieldConfig.length);

    const orderCreatedByMe = order.rm?.email === userData.user?.email;

    const deleteButton = <Button color="red" type="button" name="delete" loading={draftActionLoading} onClick={async () => {

        try {


            //just remove the order from firestore directly and go back.
            setDraftActionLoading(true);

            await deleteDoc(orderRef);

            //set field cancelled = true in kycupdatelinks collection with that orderID field
            const q = query(collection(db, "kycupdatelinks"), where("orderID", "==", order.id));
            const querySnapshot = await getDocs(q);
            await Promise.all(querySnapshot.docs.map((linkDoc) => updateDoc(linkDoc.ref, { cancelled: true })));

            const contractLinksQuery = query(collection(db, contractLinksCollection), where("productRef", "==", orderRef.path));
            const contractLinksSnapshot = await getDocs(contractLinksQuery);
            const cancelledAt = Timestamp.now();
            await Promise.all(contractLinksSnapshot.docs.map((linkDoc) => updateDoc(linkDoc.ref, {
                cancelled: true,
                status: "cancelled",
                cancelledAt,
                lastUpdated: cancelledAt,
            })));

            //go back to orders
            navigate("/orders", {
                state: {
                    refreshOrdersIn: 1000,
                }
            });
            setDraftActionLoading(false);
        }
        catch (e: any) {
            setDraftActionLoading(false);

            // Check if the error is a FirebaseError and has a specific code
            if (e?.code === 'permission-denied') {
                if (isCorporateEmail(userData.user?.email ?? "")) {

                    notifications.show({
                        title: 'Permission Denied',
                        message: <>
                            You do can only delete orders with the following status/type
                            <ul>

                                <li>
                                    Need signature
                                </li>
                                <li>
                                    Commitment
                                </li>
                                <li>
                                    Manual
                                </li>
                            </ul>
                        </>,
                        color: 'red',
                    });
                }
                else {
                    notifications.show({
                        title: 'Permission Denied',
                        message: 'You do not have permission to delete this order.',
                        color: 'red',
                    });
                }

            } else {
                notifications.show({
                    title: 'Error',
                    message: 'An error has occurred.',
                    color: 'red',
                });
            }


        }
    }}>
        Delete
    </Button>;


    const handleOrderRejection = async (values: RejectionFormValues): Promise<void> => {
        try {
            const token = await userData.getAzureADToken!(userData);
            if (!token && !userClaims?.kfh_rm_approver) {
                throw new Error("No Microsoft Token. Try refreshing.");
            }

            console.log("Order rejection values:", values);

            if (isRejectingOrder) {
                const resOrder: any = await orderAction({
                    action: "reject",
                    orderID: order.id,
                    customerID: customerRef.id,
                    token: token || "",
                    comments: values.comments,
                    sendSMS: values.sendSMS,
                    linkInfo: {
                        smsMessage: values.linkInfo?.smsMessage,
                        updateType: values.linkInfo?.updateType,
                        senderID: values.linkInfo?.senderID,
                        usePACI: values.usePACI,
                    },
                    missingFiles: values.missingFiles || [],
                });
                console.log("Order rejection result:", resOrder);

                setRefreshing(true);
                await orderRefresh({ orderID: order.id! });
                setRefreshing(false);
                console.warn("Order refreshed!");

                notifications.show({
                    title: 'Successfully',
                    message: 'Order rejected',
                    color: 'green',
                });

            } else {
                const resKYC = await kycAction({
                    action: "reject",
                    kycID: kycData?.id,
                    customerID: customerRef.id,
                    token: token || "",
                    comments: values.comments,
                    sendSMS: values.sendSMS,
                    linkInfo: {
                        smsMessage: values.linkInfo?.smsMessage,
                        updateType: values.linkInfo?.updateType,
                        senderID: values.linkInfo?.senderID,
                        usePACI: values.usePACI,
                    }
                });
                console.log("KYC rejection result:", resKYC);

                notifications.show({
                    title: 'Successfully',
                    message: 'KYC rejected',
                    color: 'green',
                });
            }

        } catch (error: any) {
            console.error("Order/KYC rejection error:", error);

            // Show error notification
            notifications.show({
                title: 'Order/KYC rejection error:',
                message: error.message || 'Failed to reject',
                color: 'red',
            });

            // Reset refreshing state if there was an error
            setRefreshing(false);

            // Re-throw the error so the modal can handle it (show error in modal)
            throw error;
        }
    };

    const formatDate = (
        timestamp: Date | { toDate(): Date } | string | number | null | undefined
    ): string => {
        if (!timestamp) return 'N/A';

        let date: Date;

        if (
            typeof timestamp === 'object' &&
            timestamp !== null &&
            'toDate' in timestamp &&
            typeof timestamp.toDate === 'function'
        ) {
            // Firestore Timestamp
            date = timestamp.toDate();
        } else if (timestamp instanceof Date) {
            // Native Date
            date = timestamp;
        } else {
            // String | number
            date = new Date(timestamp as string | number);
        }

        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };


    /**
     * Determines payment status for a badge based on amount paid vs. target.
     *
     * Amounts are rounded to the currency's decimal precision before comparison
     * to avoid float-drift bugs (e.g. 100.00000000000001 falsely reading as
     * "Overpaid"). KWD uses 3 decimals, USD/most currencies use 2.
     *
     * Note: for accurate accounting, sum payment amounts as integer minor units
     * upstream — this rounding only protects the display comparison, not the data.
     *
     * @param paid     Total amount received.
     * @param target   Amount owed (e.g. order.transferAmount).
     * @param decimals Currency decimal places (KWD = 3, USD = 2). Default 3.
     * @returns Badge color and label.
     */
    function getPaymentStatus(paid = 0, target = 0, decimals = 3) {
        const round = (n: number) => Math.round(n * 10 ** decimals) / 10 ** decimals;
        const paidAmount = round(paid);
        const transferAmount = round(target);

        if (paidAmount <= 0) return { color: "red", label: "Not Paid" };
        if (paidAmount < transferAmount) return { color: "yellow", label: "Partially Paid" };
        if (paidAmount > transferAmount) return { color: "orange", label: "Overpaid" };
        return { color: "green", label: "Fully Paid" };
    }

    const paidFromConfirmations = orderPaymentConfirmations.reduce(
        (sum, confirmation) => {
            // We need to cast the confirmation to InvoicePaymentConfirmation to access transferAmount, 
            // Due to orderPaymentConfirmations having a different type
            const conf = confirmation as InvoicePaymentConfirmation & {
                transferAmount?: number;
            };
            return sum + (conf.transferAmount ?? 0);
        },
        0
    );
    const effectivePaid = order.paidAmount ?? paidFromConfirmations;
    const paymentStatus = getPaymentStatus(effectivePaid, order.transferAmount);

    return (
        <>

            <>

                <Modal
                    opened={confirmDialog != null}
                    onClose={() => { setConfirmDialog(null); setConfirmDialogError(null); }}
                    title={<Title order={3}>{confirmDialog?.title}</Title>}
                >

                    <form onSubmit={form.onSubmit(async (values) => {
                        setConfirmDialogError(null);
                        setConfirming(true);
                        try {
                            await confirmDialog?.callback(values);
                            setConfirmDialog(null);
                        } catch (error: any) {
                            setConfirmDialogError(error.message);
                        }
                        setConfirming(false);

                    })}>
                        <Stack>

                            <Text fw={300}>{confirmDialog?.description}</Text>
                            {/* <Space h="xl"/> */}
                            {confirmDialog?.textField && <><Text>{confirmDialog?.textFieldDescription}</Text><TextInput  {...form.getInputProps(confirmDialog.textField)} /></>}
                            <Button color={confirmDialog?.buttonColor} type="submit" loading={confirming}>{confirmDialog?.action}</Button>
                            {confirmDialogError && <Alert icon={<IconAlertCircle size={16} />} title="Whoops!" c="red">{confirmDialogError}</Alert>}
                        </Stack>
                    </form>
                </Modal>

            </>
            <Space h="xl" />


            <Group justify='space-between'>
                {/* {kycData && <Title><Text tt='capitalize'>{kycData!.name_en}</Text></Title>} */}
                <MyUserDataContext.Consumer>
                    {(value) =>
                        <Group>

                            <Menu shadow="md" width={200}>
                                <Tooltip
                                    label={generatePdfDisabledReason}
                                    disabled={!generatePdfDisabledReason}
                                    withArrow
                                >
                                    <Box component="span" display="inline-block">
                                        <Menu.Target>
                                            <Button
                                                color="violet"
                                                loading={pending}
                                                disabled={!!generatePdfDisabledReason}
                                                style={{ pointerEvents: generatePdfDisabledReason ? "none" : undefined }}
                                            >
                                                Generate PDF
                                            </Button>
                                        </Menu.Target>
                                    </Box>
                                </Tooltip>

                                <Menu.Dropdown>
                                    <Menu.Label>Document</Menu.Label>
                                    <Menu.Item
                                        disabled={!docURL}
                                        component="a"
                                        href={docURL}
                                        target="_blank"

                                    >
                                        View Agreement
                                    </Menu.Item>

                                    <Menu.Divider />

                                    <Menu.Label>Actions</Menu.Label>
                                    <Menu.Item
                                        disabled={!!generateAgreementDocumentDisabledReason}
                                        onClick={

                                            () => {
                                                {
                                                    setGeneratePDFOpen(true)
                                                }
                                            }

                                        }
                                    >
                                        Generate Agreement Document
                                    </Menu.Item>
                                    {/* {order.manual && <Menu.Item
                                        onClick={
                                            () => {
                                                setGeneratePDFOpen(true)
                                            }
                                        }
                                    >
                                        Generate Empty Form
                                    </Menu.Item>} */}
                                    <Menu.Item
                                        disabled
                                        color="red"
                                        onClick={

                                            () => openConfirmModal({
                                                onConfirm: () => console.log('Confirmed'),
                                                title: 'confirm',
                                                children: (
                                                    <>
                                                        <Title order={3} c="red">
                                                            Are you sure you want to send the docuemnt to the client
                                                        </Title>
                                                        <Text size="xl" c="red">
                                                            This Action cannot be reverted
                                                        </Text>
                                                    </>
                                                ),


                                                labels: { confirm: 'Send', cancel: 'Cancel' },
                                                confirmProps: {
                                                    disabled: true,

                                                }

                                            })

                                        }

                                    >
                                        Send to client
                                    </Menu.Item>
                                </Menu.Dropdown>
                            </Menu>


                            {
                                userClaims["admin"] &&
                                <Button
                                    color="yellow"
                                    loading={pendingCreateOrderAMS}
                                    disabled={customerFullData?.tags?.kycStatus?.code !== "valid" && false}
                                    type="button"
                                    name="create_account"
                                    onClick={async () => {
                                        //send API request to create AMS
                                        setPendingCreateOrderAMS(true);
                                        try {
                                            let res = await createAMSOrder({ order: order, kyc: kycData, customer: customerFullData });

                                            console.log("Result from createAMS", res);
                                        } catch (error: any) {
                                            showNotification({
                                                id: "error",
                                                color: "red",
                                                icon: <IconX />,
                                                withBorder: true,
                                                // loading: true,
                                                message: `Error creating order: ${error.message}`,
                                                // message: 'Data will be loaded in 3 seconds, you cannot close this yet',
                                                // autoClose: true,
                                                // disallowClose: true,
                                            });

                                        }
                                        setPendingCreateOrderAMS(false);

                                    }}
                                >
                                    Create AMS Order
                                </Button>
                            }



                            {
                                (userClaims["admin"] || userClaims["cr"]) && order.tags?.orderStatus?.code === OrderStatusCode.need_slip &&
                                <Button
                                    color="red"
                                    loading={pendingPaymentRemider}

                                    type="button"
                                    name="payment_notification"
                                    onClick={async () => {
                                        //send API request to create AMS
                                        setPendingPaymentRemider(true);
                                        try {

                                            const res = await sendPaymentReminder({ orders: [orderRef.id] });
                                            console.log("Result from sendPaymentReminder", res);
                                        } catch (err: any) {

                                            console.error("Error from sendPaymentReminder", err);
                                        }
                                        setPendingPaymentRemider(false);

                                    }}
                                >
                                    Send Payment Notification
                                </Button>
                            }

                            <GeneratePDFModal
                                generatingForCollection='order'
                                getCustomerDataKey={"customerObj"}
                                completedKYCData={kycData?.completedKYCData ? {
                                    ...kycData.completedKYCData,
                                    kyc_id: kycData.id
                                } : undefined}
                                pdfTags={order.fund.kyc_redemption_product && order.skipKYC && order.type == 'redemption' ? ['order-form'] : kycData?.pdfTags ? kycData.pdfTags : undefined}
                                paymentConfirmations={orderPaymentConfirmations}
                                // fromServer={true}
                                customPath={customPath}
                                // generatedType={"order"}
                                customFileName={customFileName}
                                objID={order.id}
                                onGenerateComplete={() =>
                                    setRefetchAgreement(!refetchAgreement)
                                    // window.location.reload()
                                }
                                orderRedemptionRef={order.fund.kyc_redemption_product && order.skipKYC && order.type == 'redemption' ? orderRef : undefined}
                                rows={[{


                                    ...order,
                                    ...kycData,
                                    customerID: customerFullData?.id,
                                    id: order.id,
                                    iban: order.iban,
                                    documentActions: actionsAfterRejections,
                                    address: {
                                        ...kycData?.address, "DetailsEnglish":
                                            kycData?.address ? getAddressDetailsEnglish(kycData?.address)
                                                : "",
                                    },

                                }]}



                                // getCustomerDataKey={null}
                                documentsToFetch={
                                    [{
                                        name: "orders",
                                        subCollectionAccessorName: "id",
                                        documentsToAddFunction: (orderObj: GenericProduct) => {
                                            // Return an empty array for manual orders or when type or fund is not defined
                                            if ((order.manual && !kycData?.completedKYCData) || !orderObj?.type || !orderObj?.fund) return [];

                                            let files = ordersPath[orderObj?.type as SubscriptionType][orderObj.fund.id];
                                            const fundsMap = globalDataContext?.fundsMap;

                                            // New KYC open_ended fund no need to get file from public
                                            const isNewKYC = !!(
                                                orderObj?.fund?.type === 'open_ended' &&
                                                (
                                                    (orderObj.type === 'subscription' && orderObj.fund?.kyc_product) ||
                                                    (orderObj.type === 'redemption' && orderObj.fund?.kyc_redemption_product)
                                                )
                                            );
                                            if (isNewKYC) {
                                                return [];
                                            }
                                            if (fundsMap) {
                                                const orderPath = fundsMap[orderObj.fund.id]?.orders_path;
                                                if (orderObj?.type === "subscription") {
                                                    files = orderPath?.subscription ?? files;
                                                } else if (orderObj?.type === "redemption") {
                                                    files = orderPath?.redemption ?? files;
                                                }
                                            }

                                            return files;
                                        },
                                        type: "collectionGroup"

                                    }]
                                }

                                metaTypes={metaTypes}
                                manual={kycData?.completedKYCData ? false : order.manual}
                                //set the kyc id to be used in case of manual as in that case we dont use latest valid kyc
                                kycID={kycData?.id}
                                opened={generatePDFOpen}
                                setOpened={setGeneratePDFOpen}
                                manualEmptyFiles={emptyOrderFilePath}


                            />
                            <GeneratePDFModal
                                generatingForCollection="order"
                                getCustomerDataKey={"customerObj"}
                                // generatedType={"order"}
                                objID={order.id}
                                rows={[{
                                    ...order,
                                    ...kycData,
                                    customerID: customerFullData?.id,
                                    id: order.id,
                                    iban: order.iban,
                                    documentActions: actionsAfterRejections,
                                    address: {
                                        ...kycData?.address, "DetailsEnglish":
                                            kycData?.address ? getAddressDetailsEnglish(kycData?.address)
                                                : "",
                                    },
                                }]}



                                // getCustomerDataKey={null}
                                documentsToFetch={
                                    [{
                                        name: "orders",
                                        subCollectionAccessorName: "id",
                                        documentsToAddFunction: (orderObj: GenericProduct) => {
                                            //if order is manual then in that case this modal will be used to generate empty forms there for we return [] and add the list of document needed in manualEmptyFiles
                                            if (!orderObj?.type || !orderObj?.fund) return [];

                                            let files = ordersPath[orderObj?.type as SubscriptionType][orderObj.fund.id];
                                            const fundsMap = globalDataContext?.fundsMap;

                                            if (fundsMap) {
                                                const orderPath = fundsMap[orderObj.fund.id]?.orders_path;
                                                if (orderObj?.type === "subscription") {
                                                    files = orderPath?.subscription ?? files;
                                                } else if (orderObj?.type === "redemption") {
                                                    files = orderPath?.redemption ?? files;
                                                }
                                            }

                                            return files;
                                        },
                                        type: "collectionGroup"
                                    }]
                                }
                                metaTypes={metaTypes}
                                manual={order.manual}
                                withFilledKYC={true}
                                //set the kyc id to be used in case of manual as in that case we dont use latest valid kyc
                                kycID={kycData?.id}
                                opened={generateFilledPDFOpen}
                                setOpened={setGenerateFilledPDFOpen}


                            />
                            {generatePdfDisabledReason && <Text fs="italic" c="dimmed">{generatePdfDisabledReason}</Text>}

                            {/* {value.user?.email === "yalhusayan@kfhcapital.com.kw" && */}
                            <Button color="green" loading={refreshing} type="button" onClick={

                                async () => {

                                    setRefreshing(true);
                                    await orderRefresh({ orderID: order.id! });
                                    setRefreshing(false);
                                    console.warn("Order refreshed!");
                                }

                            }>
                                Refresh Order
                            </Button>

                            {/* Hide Upload Slip if user paid via KFH Online app*/}
                            {!order.payment_confirmations?.length && (
                                <Button onClick={() => setUploadSlipOpened(true)} disabled={orderStatusCode === "rejected"}>
                                    Upload Slip {orderStatusCode === "rejected" ? " (Order Rejected)" : ""}
                                </Button>
                            )}

                            {order.manual && <Button color='pink' onClick={() => setUploadFinalSignedAgreementOpened(true)} disabled={orderStatusCode === "rejected"}>
                                Upload Agreement
                            </Button>}



                            <Modal
                                size={"xl"}
                                opened={uploadSlipOpened}
                                onClose={() => {

                                    //remove any uploaded slips
                                    bankAccountForm.values.slipFilePaths?.forEach((slipPath) => {
                                        ///
                                        const deleteRef = ref(storage, `${slipPath}`);

                                        deleteObject(deleteRef).then(() => {
                                            orderRefresh({ orderID: order.id! }).then(() => {

                                                setForceRefreshFiles(Math.random())

                                            });

                                            // File deleted successfully
                                        }).catch((error) => {

                                            console.error(error);

                                            // Uh-oh, an error occurred!
                                        });
                                    })


                                    setUploadSlipOpened(false);
                                }}
                                title="Upload Slip"
                            >

                                <form onSubmit={bankAccountForm.onSubmit(async (values) => {

                                    if (!values.iban || !values.transferDate) {
                                        // setIsError(true);
                                        // setMsg("Please fill out all fields");
                                        return;
                                    }

                                    setPending(true);

                                    try {
                                        const slipFilePaths = bankAccountForm.values.slipFilePaths || [];
                                        if (!slipFilePaths.length) {
                                            throw new Error("Please upload at least one slip before finalizing");
                                        }

                                        const formData = new FormData();
                                        formData.append("type", "order_slip");
                                        formData.append("orderID", order.id!);
                                        formData.append("finalizeSlip", "true");
                                        formData.append("iban", values.iban);
                                        formData.append("acct", values.account || "");
                                        formData.append("transferDate", formatTransferDateForUpload(values.transferDate));
                                        slipFilePaths.forEach((slipPath: string) => {
                                            formData.append("slipFilePaths[]", slipPath);
                                        });

                                        const response = await (await fetch(`${appConfigContext.apiUrl}/uploadFile`, {
                                            method: "POST",
                                            body: formData,
                                        })).json() as UploadFileResult & { reason?: any };

                                        if (response.status === "error") {
                                            throw new Error(response.message || response.reason?.message || "Failed to finalize slip");
                                        }

                                        console.warn("Order refreshed!");
                                        setForceRefreshFiles(Math.random())
                                        await orderRefresh({ orderID: order.id! });
                                        bankAccountForm.reset()
                                        setUploadSlipOpened(false)
                                    } catch (error) {
                                        console.error(error);
                                        setIsError(true);
                                        setMsg((error as Error)?.message || "Failed to upload slip");
                                        await orderRefresh({ orderID: order.id! });
                                    } finally {
                                        setPending(false);
                                    }
                                    setForceRefreshFiles(Math.random())

                                })}>
                                    <BankAccountInfo
                                        ibanProps={
                                            {
                                                ...bankAccountForm.getInputProps("iban")
                                                ,
                                                required: true
                                            }

                                        }
                                        transferDateProps={
                                            {
                                                ...bankAccountForm.getInputProps("transferDate"),
                                                required: true
                                            }
                                        }
                                        acctNumberProps={
                                            { ...bankAccountForm.getInputProps("account"), }
                                        }
                                        orderID={order.id}
                                        deferFinalize={true}
                                        onBlurIban={
                                            () => {
                                                console.log("Blurring!");
                                                if (bankAccountForm.values?.iban && bankAccountForm.values.iban.length === 30) {
                                                    let acct = getKFHAccountNo(bankAccountForm.values.iban);
                                                    if (acct) {
                                                        bankAccountForm.setFieldValue("account", acct);
                                                    }
                                                }
                                            }
                                        }

                                        onBlurAccountNumber={
                                            () => {
                                                if (bankAccountForm.values.account && bankAccountForm.values.account.length === 12) {
                                                    bankAccountForm.setFieldValue("iban", generateIBANFromKFHAccountNo(bankAccountForm.values.account) || "");
                                                }
                                            }

                                        }

                                        handleUploadResponse={
                                            (response: UploadFileResult, filesName: string[], setUploadedFiles?: (values?: FileWithPath[]) => void, filesList?: CustomFileWithPath[], currentFiles?: FileWithPath[]) => {


                                                filesName.map((fileName: string) => {
                                                    const fileInfo = response.info![fileName];
                                                    console.log(fileInfo)


                                                    if (fileInfo && setUploadedFiles) {
                                                        if (filesList) {

                                                            setUploadedFiles(
                                                                currentFiles?.concat({ ...fileInfo, name: fileName, serverPath: (fileInfo as CustomFileWithPath).serverPath })
                                                            )
                                                        }
                                                    }

                                                    if (fileInfo.metadata?.acct) bankAccountForm.setFieldValue("account", fileInfo.metadata?.acct);
                                                    if (fileInfo.metadata?.iban) bankAccountForm.setFieldValue("iban", fileInfo.metadata?.iban);

                                                    if (fileInfo.metadata?.amount) bankAccountForm.setFieldValue("transferAmount", fileInfo.metadata?.amount);

                                                    if (fileInfo.metadata?.transferDate) {
                                                        let d = fileInfo.metadata?.transferDate.split("/");
                                                        let transferDate = new Date(`${d[1]}-${d[0]}-${d[2]}`);
                                                        console.log("Setting transfer date to", transferDate);
                                                        bankAccountForm.setFieldValue("transferDate", transferDate);
                                                    }

                                                    return fileInfo.filepath;
                                                })
                                                if (response.filePaths?.length) {
                                                    bankAccountForm.setFieldValue("slipFilePaths", response.filePaths)

                                                }
                                                else {

                                                    bankAccountForm.setFieldValue("slipFilePaths", response.info!.filepaths)
                                                }



                                            }

                                        }

                                        setIsError={setIsError}
                                        setMsg={setMsg}
                                        clearFiles={clearFiles}
                                        onRemoveFile={
                                            (file) => {
                                                {
                                                    const deleteRef = ref(storage, `${(file as CustomFileWithPath).serverPath}`);

                                                    // Delete the file
                                                    deleteObject(deleteRef).then(() => {
                                                        orderRefresh({ orderID: order.id! }).then(() => {

                                                            setForceRefreshFiles(Math.random())


                                                        });

                                                        // File deleted successfully
                                                    }).catch((error) => {

                                                        console.error(error);

                                                        // Uh-oh, an error occurred!
                                                    });
                                                }
                                                bankAccountForm.setFieldValue("slipFilePaths",
                                                    bankAccountForm.values.slipFilePaths?.filter((path: string) => (path?.split("/").pop() !== (file as CustomFileWithPath).serverPath?.split("/").pop())
                                                    ))


                                                // orderRefresh({ orderID: order.id! });


                                            }
                                        }

                                    />




                                    {
                                        msg != null &&   //love my check if it's an error or not.  Please don't do this, it's just a proof of concept page.
                                        <Alert color={isError ? "red" : "green"}>
                                            {msg}
                                        </Alert>
                                    }

                                    <Group justify="center" mt="md">
                                        <Button
                                            type="submit"
                                            loading={pending}
                                        // disabled={isSubmitted}
                                        >
                                            Upload Slip
                                        </Button>
                                        <Button
                                            loading={pending}
                                            color="red" type="button"
                                            // disabled={isSubmitted}
                                            onClick={() => {
                                                setClearFiles(Math.random())
                                                //remove any uploaded slips
                                                bankAccountForm.values.slipFilePaths?.forEach((slipPath) => {
                                                    ///
                                                    const deleteRef = ref(storage, `${slipPath}`);

                                                    deleteObject(deleteRef).then(() => {
                                                        orderRefresh({ orderID: order.id! }).then(() => {

                                                            setForceRefreshFiles(Math.random())

                                                        });

                                                        // File deleted successfully
                                                    }).catch((error) => {

                                                        console.error(error);

                                                        // Uh-oh, an error occurred!
                                                    });
                                                })

                                                setUploadSlipOpened(false)
                                                setMsg(null)

                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Group>
                                </form>
                            </Modal>
                            <Modal
                                size={'xl'}
                                opened={uploadFinalSignedAgreementOpened}
                                onClose={() => { setUploadFinalSignedAgreementOpened(false); }}
                                title="Signed Agreement"
                            >
                                <Card withBorder>
                                    <UploadBox
                                        loading={finalSignedAgreementLoading}
                                        label="Drag Signed Agreement here or click to select file"
                                        multiple={false}
                                        onDropAny={async (files, filesRejected: FileRejection[], setUploadedFiles, uploadedFiles?: FileWithPath[]) => {

                                            if (!files || files?.length === 0) return;
                                            console.log("Files dropped!", files, filesRejected, uploadedFiles);

                                            setFinalSignedAgreementLoading(true);
                                            //upload file to fileUpload endpoint
                                            const promises = files.map(async (file) => {
                                                let tags: Record<string, string> = {};
                                                tags.finalSignedAgreement = 'true';
                                                if (order.id) {
                                                    await uploadToStorage(file, 'orders/' + order.id, tags);
                                                }
                                                if (customerFullData.id) {
                                                    await uploadToStorage(file, 'kyc/' + customerFullData.id, tags);
                                                }
                                                if (agreementFileRef) {
                                                    await uploadBytesResumable(ref(agreementFileRef, customFileName), file);
                                                }
                                            });

                                            await Promise.all(promises);
                                            // const messaging = getMessaging(getApp());

                                            //wait 6 seconds.  I can't know when the thumbnail is ready.
                                            await new Promise((resolve) => {
                                                setTimeout(() => {
                                                    resolve(true);
                                                }, 6000);
                                            });
                                            setUploadFinalSignedAgreementOpened(false);
                                            setFinalSignedAgreementLoading(false);
                                        }}
                                    />
                                </Card>
                            </Modal>

                        </Group>

                    }
                </MyUserDataContext.Consumer>

            </Group>

            <Space h="xl" />
            <Accordion multiple variant='contained' transitionDuration={1000}
                // defaultValue={['kyc', 'order']}

                value={openAccordions}
                onChange={setOpenAccordions}



            >
                <Accordion.Item key="kyc" value="kyc" >
                    <Accordion.Control disabled={!(kycState && customerFullData)} >
                        <Group p="apart">
                            <ThemeIcon
                                variant="gradient"
                                size="xl"
                                aria-label="Gradient action icon"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                            >
                                <IconScript size={30} />
                            </ThemeIcon>
                            <Text
                                component="span"
                                ta="center"
                                variant="gradient"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                                size="xl"
                                fw={700}
                            // style={{ fontFamily: 'Greycliff CF, sans-serif' }}
                            >
                                KYC Information ({
                                    // kycCompleted ? kycTags?.title : 
                                    kycState?.status ||
                                    "No KYC"})
                            </Text>
                            <Text component='span'
                                c="red"
                                fw={700}

                            >
                                {orderSkipsKYC ? "KYC Skipped" : outdatedKyc ? "--Too old--" : ""}
                            </Text>
                        </Group>

                    </Accordion.Control>
                    <Accordion.Panel>

                        {/* below is the old disableUpload condition */}
                        {/* kycState?.status_code === "rejected" || orderStatusCode === "rejected" */}
                        {!order.kyc_id &&
                            <>
                                <Space h="xl" />

                                <Text c="red"> Waiting for client to submit the "order" specific KYC, currently showing latest client details</Text>
                                <Space h="xl" />
                            </>
                        }

                        <CustomerKYC
                            kycID={order.kyc_id}
                            metaTypes={metaTypes}
                            setMetaTypes={setMetaTypes}
                            disableUpload={orderStatusCode === "rejected"}
                            customerData={customerFullData!}
                            showButton={true}
                            showActiveLinks={true}
                            showKycVersion={false}
                            showGeneratePDF={false} />


                        {/* )} */}
                    </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item key="order" value="order">
                    <Accordion.Control >
                        <Group p="apart">
                            <ThemeIcon
                                variant="gradient"
                                size="xl"
                                aria-label="Gradient action icon"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                            >
                                <IconCreditCard size={30} />
                            </ThemeIcon>
                            <Text
                                component="span"
                                ta="center"
                                variant="gradient"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                                size="xl"
                                fw={700}
                                style={{ fontFamily: 'Greycliff CF, sans-serif' }}
                            >
                                Order Information
                            </Text>
                        </Group>
                    </Accordion.Control>
                    <Accordion.Panel>


                        <Space h="xl" />


                        {order &&

                            <SimpleGrid cols={3}>

                                <EditableInfoCard
                                    title="Order Information"
                                    color="teal"
                                    itemDoc={orderDoc}
                                    updatedItemData={updatedOrderData}
                                    icon={<IconShoppingCart size={16} />}
                                    attention={
                                        (isSubscription &&
                                            order.tags?.paid?.code === "paid" &&
                                            !order.transferDate) || unitsShortfall
                                    }
                                    list={[

                                        {
                                            label: 'Date',
                                            value: order.created?.toDate().toDateString()
                                        },

                                        {
                                            label: 'Fund',
                                            value: order.fund.name_en
                                        },
                                        {

                                            label: 'Type',
                                            value: order.type
                                        },
                                        {
                                            label: "KYC Status",

                                            value: <>


                                                {(customClaims.kfh_rm || customClaims.kfh_oper || customClaims.kfh_rm_approver) ?
                                                    order.kyc_id ? < Link to={`/customers/${customerRef?.id}/kyc/${order.kyc_id}`}>

                                                        <Text c="yellow">{order.kyc_id ? kycState?.status || "No KYC" : `Recent KYC (${kycState?.status || "No KYC"})`}</Text>
                                                    </Link> :
                                                        <Text size='xs' c="yellow">No KYC Related To order yet (check if the client submitted the order's kyc)</Text>

                                                    :

                                                    < Link to={`/customers/${customerRef?.id}/`}>

                                                        <Text c="yellow">{order.kyc_id ? kycState?.status || "No KYC" : `Recent KYC (${kycState?.status || "No KYC"})`}</Text>
                                                    </Link>
                                                }


                                            </>

                                        },
                                        {

                                            label: 'KYC ID',
                                            value: order?.kyc_id,
                                            noCapitalize: true,
                                        },

                                        {
                                            label: 'Transfer Date',
                                            editable: (userClaims["admin"] || userClaims["cr"]) && isSubscription,
                                            fieldName: "transferDate",
                                            componentType: "Timestamp",
                                            value: isSubscription
                                                ? (order.transferDate?.toDate().toDateString()
                                                    ?? <Text span c="red" fw={500} size="sm">Missing</Text>)
                                                : undefined,
                                        },

                                        {
                                            label: 'Approval Date',
                                            value: order.approvedAt?.toDate().toDateString()
                                        },

                                        {
                                            label: 'Transfer Amount',
                                            fieldName: "transferAmount",
                                            value: order.type === "subscription"
                                                ? (
                                                    <>
                                                        <Text span fw={500} size="sm" ta="right">
                                                            <NumberFormatter thousandSeparator value={order.transferAmount ?? 0} suffix={" " + order.fund.currency} />
                                                        </Text>
                                                        <EditTransferAmount order={order} />
                                                    </>
                                                )
                                                : undefined,
                                        },

                                        {
                                            label: 'Expected NAV Date',
                                            editable: (userClaims["admin"] || userClaims["cr"]) && order.fund.type === "open_ended",
                                            fieldName: "expected_nav_date",
                                            componentType: "NavTimestamp",
                                            navUpdateDayOfWeek: order.fund.nav_update_day_of_week,
                                            handleChange: (value) => ({
                                                expected_nav_date: normalizeExpectedNavDate(value instanceof Timestamp ? value : null),
                                            }),
                                            value: order.expected_nav_date ? (
                                                <>
                                                    <Text span fw={500} size="sm">
                                                        {formatExpectedNavDate(order.expected_nav_date)}
                                                    </Text>
                                                    {expectedNavDateOverridden && (
                                                        <Text span size="xs" c="orange" ml={4}>
                                                            Manual override
                                                        </Text>
                                                    )}
                                                </>
                                            ) : undefined
                                        },
                                        {
                                            label: 'NAV Date',
                                            value: order.nav_date?.toDate().toDateString()   //this has been a source of many crashes.
                                        },
                                        {
                                            label: 'NAV per unit',
                                            value: order.nav_per_unit ? <Text fw={500} size="sm" ta="right"><NumberFormatter thousandSeparator value={order.nav_per_unit} suffix={" " + order.fund.currency} /></Text> : undefined
                                        },

                                        {
                                            label: order.type === "subscription" ? 'Subscription Amount' : 'Redemption Amount',
                                            editable: userClaims["admin"] && !order.fund.fees_included_in_transferred_amount && order.type === "subscription",
                                            fieldName: "postNavAmount",
                                            componentType: "NumberInput",
                                            handleChange: (value) => {
                                                const numValue = Number(value)
                                                let fees_percent = 0;
                                                order.fund = {
                                                    ...order.fund,
                                                    ...latestFundData
                                                };

                                                if (order.fund.subscription_tiers) {
                                                    fees_percent = ((order.fund.subscription_tiers.find(t => numValue >= t.from && numValue <= t.to)?.fees || 0))
                                                } else if (order.fund?.subscription_fees_percent) {
                                                    fees_percent = order.fund?.subscription_fees_percent;
                                                }

                                                const result = calc(
                                                    order,
                                                    undefined,
                                                    numValue,
                                                    undefined,
                                                    undefined
                                                )
                                                let fees = numValue * (fees_percent / 100);

                                                let transferAmount = numValue + fees
                                                return { units: result?.amt || 0, fees: fees, transferAmount: transferAmount, fund: order.fund };
                                            },
                                            value: order.postNavAmount
                                                ? <Text span fw={500} size="sm"><NumberFormatter thousandSeparator value={order.postNavAmount} suffix={" " + order.fund.currency} /></Text>
                                                : <Text span fs="italic" c="dimmed" size="sm">No NAV yet</Text>
                                        },
                                        {
                                            label: 'Fees',
                                            value: order.fees ? <Text span fw={500} size="sm" ta="right"><NumberFormatter thousandSeparator value={order.fees} suffix={" " + order.fund.currency} /></Text> : undefined
                                        },
                                        {
                                            label: order.units ? 'Units' : 'Estimated Units',
                                            fieldName: "units",
                                            value: <>
                                                <Text span fw={500} size="sm" ta="right" c={unitsShortfall ? "red" : undefined}>

                                                    {order.units === 0 ? "All Units" :
                                                        <NumberFormatter thousandSeparator value={order.units ?? order.estimated_units} />}

                                                </Text>
                                                {unitsEditable &&
                                                    <>
                                                        <EditTransferAmount order={order} />
                                                    </>
                                                }
                                            </>
                                        },

                                        {
                                            label: 'Surplus',

                                            value: isSubscription && order.surplus && order.surplus > 0 ? <Text fw={500} size="sm" ta="right"><NumberFormatter thousandSeparator value={order.surplus} suffix={" " + order.fund.currency} /></Text> : undefined

                                        },
                                        {
                                            label: 'Incentive',
                                            value: ((userClaims.admin || userClaims.oper) && isSubscription) ? <>{(order?.units || 0) * (order?.nav_per_unit || 0) * 0.01}</> : undefined
                                        },
                                        {
                                            label: 'Voting',

                                            value: order.voting === undefined
                                                ? undefined
                                                : order.voting
                                                    ? <ThemeIcon radius="xl" size="xs" color="green">
                                                        {" "}
                                                        <IconCheck size={12} />{" "}
                                                    </ThemeIcon>
                                                    : <ThemeIcon radius="xl" size="xs" color="red">
                                                        <IconX size={12} />
                                                    </ThemeIcon>

                                        },

                                    ]}

                                />
                                <IbanInfoCard
                                    acct={order.acct}
                                    customerRef={customerRef}
                                    entityLabel="order"
                                    entityRef={orderRef}
                                    iban={order.iban}
                                    ibanVerified={order.ibanVerified}
                                    userClaims={userClaims}
                                    verifiedBy={order.verifiedBy}
                                    verifierIdentity={userData.user?.email || userData.user?.uid || 'Unknown user'}
                                />


                                {shouldShowGenevaResponseCard && (
                                    <CustomInfoCard
                                        title="Geneva Responses"
                                        color="pink"
                                        attention={genevaResponsesNeedAttention}
                                        icon={<IconGalaxy size={16} />}
                                        list={genevaResponseList}
                                    />
                                )}


                                <CustomInfoCard
                                    title="Client Information"
                                    color="yellow"
                                    icon={<IconPhone size={16} />}
                                    list={[
                                        {
                                            label: "Name (en)",
                                            value: customerFullData?.name_en,
                                        },
                                        {
                                            label: "Name (ar)",
                                            value: customerFullData?.name_ar,
                                        },
                                        {
                                            label: "Commercial Register",
                                            value: customerFullData?.commercial_register,
                                        },

                                        {
                                            label: "Civil ID",
                                            value: customerFullData?.civilID,
                                        },
                                        {
                                            label: "Civil ID Expiry",
                                            value: paciData?.civilIDExpiryDate?.toDate().toLocaleDateString("en-gb")
                                        },

                                        {
                                            label: "Mobile",
                                            value: customerFullData?.mobile,
                                        },
                                        {
                                            label: "Nationality",
                                            value: customerFullData?.nationality,
                                        },
                                        {
                                            label: "Gender",
                                            value: customerFullData?.gender,
                                        },
                                        {
                                            label: "PACI Sponsor",
                                            value: order.paciData?.PersonalData?.GovData?.SponsorName || undefined
                                        },
                                        {
                                            label: "PACI Mobile",
                                            value: order.paciData?.PersonalData?.MobileNumber || undefined
                                        },
                                        {
                                            label: "PACI Email",
                                            value: order.paciData?.PersonalData?.EmailAddress || undefined,
                                            noCapitalize: true,
                                        },

                                        {
                                            label: "Address (en)",
                                            value: paciData?.address?.DetailsEnglish,
                                        },

                                        {
                                            label: "Address (ar)",
                                            value: paciData?.address?.DetailsArabic,
                                        },
                                        {
                                            label: "Address",
                                            value: paciData?.address ? getAddressDetailsEnglish(paciData?.address) : null,
                                        },
                                        // ...Object.keys(data?.address).map((key) => {return {label: key, value: data?.address[key]}} )
                                    ]}
                                />


                                <RmInformationCard
                                    product={order}
                                    onEditRm={userClaims["admin"] ? () => setChangeRmOpen(true) : undefined}
                                    onEditReferredBy={userClaims["admin"] ? () => setChangeReferredByRmOpen(true) : undefined}
                                />


                                {order.signature &&


                                    <CustomInfoCard
                                        title="Signature"
                                        color="violet"
                                        icon={
                                            <IconSchool size={16} />
                                        }
                                        list={[

                                            {
                                                label: '',
                                                value: order.signature && <Image
                                                    fit="contain"
                                                    w="auto"
                                                    mah={200}
                                                    maw="100%"
                                                    src={`data:image/png;base64,${order.signature}`}
                                                />
                                            },


                                        ]}
                                    />
                                }

                                {order && orderPaymentConfirmations.length > 0 && (
                                    <Paper key="unmatched-confirmations" shadow="xs" p="md">
                                        <Group justify="space-between" wrap="nowrap" align="flex-start" mb="sm">
                                            <Group wrap="nowrap" gap="xs">
                                                <ThemeIcon color={paymentStatus.color} variant="light">
                                                    <IconMoneybag size={16} />
                                                </ThemeIcon>
                                                <Title order={5}>Payment Confirmation</Title>
                                            </Group>
                                            <Badge color={paymentStatus.color} variant="light">{paymentStatus.label}</Badge>
                                        </Group>
                                        <Stack gap="xs">
                                            <Group justify="space-between">
                                                <Text size="sm" c="dimmed">Subscription Amount</Text>
                                                <Text fw={500} size="sm" ta="right">
                                                    <NumberFormatter thousandSeparator value={order.transferAmount} />
                                                </Text>
                                            </Group>
                                            {order.iban && (
                                                <Group justify="space-between" wrap="nowrap">
                                                    <Text size="sm" c="dimmed">IBAN</Text>
                                                    <Text fw={500} size="sm" ta="right" style={{ wordBreak: 'break-all' }}>
                                                        {order.iban}
                                                    </Text>
                                                </Group>
                                            )}

                                            {order.paidAmount && (
                                                <Group justify="space-between">
                                                    <Text size="sm" c="dimmed">Paid</Text>
                                                    <Text fw={500} size="sm" c="green" ta="right">
                                                        <NumberFormatter thousandSeparator value={order.paidAmount} />
                                                    </Text>
                                                </Group>
                                            )}

                                            {(order.remainingAmount ?? 0) > 0 && (
                                                <Group justify="space-between">
                                                    <Text size="sm" c="dimmed">Remaining</Text>
                                                    <Text fw={500} size="sm" c="orange" ta="right">
                                                        <NumberFormatter thousandSeparator value={order.remainingAmount} />
                                                    </Text>
                                                </Group>
                                            )}


                                            {orderPaymentConfirmations.length > 0 && (
                                                <>
                                                    <Divider
                                                        my="md"
                                                        label={
                                                            orderPaymentConfirmations.length > 1
                                                                ? `Payment Confirmations (${orderPaymentConfirmations.length})`
                                                                : 'Payment Confirmation'
                                                        }
                                                        labelPosition="left"
                                                    />
                                                    <Accordion variant="separated" radius="sm" multiple chevronPosition="right">
                                                        {orderPaymentConfirmations.map((confirmation, confIdx) => {
                                                            // Adding transferAmount and transferCurrency to the confirmation object for display purposes
                                                            const conf = confirmation as InvoicePaymentConfirmation & {
                                                                transferAmount?: number;
                                                                transferCurrency?: string;
                                                            };
                                                            return (
                                                                <Accordion.Item
                                                                    key={`conf-${order.id}-${confIdx}`}
                                                                    value={`conf-${order.id}-${confIdx}`}
                                                                >
                                                                    <Accordion.Control>
                                                                        <Group justify="space-between" wrap="nowrap" pr="sm">
                                                                            <Text size="sm" fw={600}>
                                                                                Payment #{confIdx + 1}
                                                                            </Text>
                                                                            <Text size="sm" fw={500}>
                                                                                {conf.transferAmount != null
                                                                                    ? <NumberFormatter thousandSeparator value={conf.transferAmount} />
                                                                                    : "-"}
                                                                                {' '}{conf.transferCurrency ?? ''}
                                                                            </Text>
                                                                        </Group>
                                                                    </Accordion.Control>
                                                                    <Accordion.Panel>
                                                                        <Stack gap={4}>
                                                                            {confirmation.amountInKWD != null && (
                                                                                <Group justify="space-between">
                                                                                    <Text size="xs" c="dimmed">Amount (KWD)</Text>
                                                                                    <Text size="sm" ta="right">
                                                                                        <NumberFormatter thousandSeparator value={confirmation.amountInKWD} />
                                                                                    </Text>
                                                                                </Group>
                                                                            )}
                                                                            {confirmation.exchangeRate != null && (
                                                                                <Group justify="space-between">
                                                                                    <Text size="xs" c="dimmed">Exchange Rate</Text>
                                                                                    <Text size="sm" ta="right">
                                                                                        <NumberFormatter thousandSeparator value={confirmation.exchangeRate} />
                                                                                    </Text>
                                                                                </Group>
                                                                            )}
                                                                            <Group justify="space-between" wrap="nowrap">
                                                                                <Text size="xs" c="dimmed">From IBAN</Text>
                                                                                <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                                    {confirmation.fromIban}
                                                                                </Text>
                                                                            </Group>
                                                                            <Group justify="space-between">
                                                                                <Text size="xs" c="dimmed">Date</Text>
                                                                                <Text size="xs" ta="right">
                                                                                    {confirmation.transactionTimestamp?.toDate().toLocaleString("en-gb") ?? confirmation.transactionDate}
                                                                                </Text>
                                                                            </Group>
                                                                            {confirmation.transactionID && (
                                                                                <Group justify="space-between" wrap="nowrap">
                                                                                    <Text size="xs" c="dimmed">Transaction ID</Text>
                                                                                    <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                                        {confirmation.transactionID}
                                                                                    </Text>
                                                                                </Group>
                                                                            )}
                                                                        </Stack>
                                                                    </Accordion.Panel>
                                                                </Accordion.Item>
                                                            );
                                                        })}
                                                    </Accordion>
                                                </>
                                            )}
                                        </Stack>
                                    </Paper>
                                )}
                            </SimpleGrid>
                        }

                        {/* Show photos from firebase storage */}
                        <Space h="xl" />

                        <Stack>
                            {
                                <>
                                    <Title order={3}>Files</Title>
                                    <FilesList
                                        forceRefresh={forceRefreshFiles}
                                        setMetaTypes={setMetaTypes}
                                        path={`orders/${id}/`}
                                        links={links}
                                        setLinks={setLinks}
                                        onChange={() => {
                                            orderRefresh({ orderID: order.id! });
                                            // if (order.id) {
                                            //     areAllFolderFilesTagged(`orders/${order.id}/`).then((res) => {
                                            //         setAllFilesTagged(res);
                                            //     }).catch((err) => {
                                            //         setAllFilesTagged(false);
                                            //     });
                                            // };

                                        }}
                                        showUploader={!!customClaims?.admin} // only show uploader for admins
                                    />
                                </>}

                            {/* Show product comments */}
                            <Space h="xl" />
                            <Stack gap="md">
                                <Grid gap="lg">
                                    {/* show approval */}
                                    {actions && actions.length > 0 && (<Grid.Col span={{ base: 12, md: 6 }}>
                                        <CustomProductTimeline approval={actions} />
                                    </Grid.Col>)}
                                    <Grid.Col span={{ base: 12, md: 6 }}>
                                        {/* Show product comments */}
                                        <CustomProductComment
                                            collectionRef={orderRef}
                                        />
                                    </Grid.Col>
                                </Grid>
                                <Box mt="md" pt="md" style={{ borderTop: '1px solid var(--mantine-color-gray-3)' }} />
                            </Stack>
                        </Stack>

                        {unitsShortfall && (
                            <Alert color="red" variant="light" title="Insufficient units for this redemption" icon={<IconAlertCircle size={16} />} mb="md">
                                <Text size="sm">
                                    The order requests {order.units === 0 ? "all units" : <NumberFormatter thousandSeparator value={order.units} />} but the customer currently holds <NumberFormatter thousandSeparator value={customerFundUnits ?? 0} /> units of {order.fund.name_en}. Reviewing and approving is still allowed, but the redemption will fail unless the units are corrected or the customer's holdings are updated.
                                </Text>
                            </Alert>
                        )}

                        <Grid w="100%" >



                            {orderStatusCode !== "commitment" &&

                                <Grid.Col span={4}>
                                    <ConfigContext.Consumer>
                                        {
                                            (config) => {
                                                let actionToTakeLabel: string | null = null;
                                                let actionToTake: ActionType | null = null;
                                                let actionColor: string = "";
                                                let isOrderAndKycSameState = false;
                                                let isWaitingKFHApprove = false;

                                                //TODO: We don't need approvers anymore I believe.  We can just rely on the custom claims.  Let's rewrite it to remove approvers.
                                                //

                                                //TODO: I think I need to refactor this into something more general
                                                //      since I'll most likely use it somewhere else.
                                                if (!order) return null;
                                                //change buttons based on state




                                                if (!config || !config.approvers) return null;


                                                if (userClaims?.kfh_rm_approver) {
                                                    let kfhApprovers = config.approvers.kfh_approvers;
                                                    console.log("kfhApprovers", kfhApprovers);
                                                    let isKFHApprover = kfhApprovers.includes(userData.user?.email ?? "");
                                                    if (!isKFHApprover) return null;
                                                    if (orderStatusCode === "selling_agent_review") {
                                                        if (kycState?.risk_code !== "high") {
                                                            if (["selling_agent_review", "review", "approval", "valid"].includes(kycState?.status_code!)) {


                                                                actionToTakeLabel = "Review";
                                                                actionToTake = "selling_agent_review";
                                                                actionColor = "teal";
                                                                isWaitingKFHApprove = true;
                                                                if ((kycState?.status_code as any) === orderStatusCode) {
                                                                    actionToTakeLabel = actionToTakeLabel + " (Order & KYC)";
                                                                    isOrderAndKycSameState = true;
                                                                }
                                                            }
                                                        } else {
                                                            if (["approval", "review", "valid"].includes(kycState?.status_code)) {


                                                                actionToTakeLabel = "Review";
                                                                actionToTake = "selling_agent_review";
                                                                actionColor = "teal";
                                                                isWaitingKFHApprove = true;

                                                            }
                                                        }
                                                    }
                                                }
                                                else {


                                                    if (!userData || !userData.msal || !(userData.msal.idTokenClaims as any).groups) return null;

                                                    let groups = (userData.msal.idTokenClaims as any).groups;

                                                    //loop through all groups and see if they intersect.
                                                    let approvers = config.approvers.kyc_normal;
                                                    let execApprovers = config.approvers.kyc_executive;
                                                    let isApprover = groups.some((group: string) => approvers.includes(group));
                                                    let isExecApprover = groups.some((group: string) => execApprovers.includes(group));
                                                    let isOperationsApprover = customClaims.oper;



                                                    if (!isApprover && !isExecApprover && !isOperationsApprover) return null;

                                                    // if (isApprover && data.approvedBy) return null;
                                                    // if (isExecApprover && data.approvedByExec) return null;


                                                    //loop backwards through actionsData and get the last actions that were after needs_update






                                                    if (orderStatusCode === "review" || orderStatusCode === "selling_agent_review") {
                                                        actionToTakeLabel = "Review";
                                                        actionToTake = "review";
                                                        actionColor = "cyan";
                                                        if ((kycState?.status_code as any) === orderStatusCode && kycState?.risk_code !== "high") {
                                                            actionToTakeLabel = actionToTakeLabel + " (Order & KYC)";
                                                            isOrderAndKycSameState = true;
                                                        }
                                                    }

                                                    else if (orderStatusCode === "approval") {
                                                        actionToTakeLabel = "Approve";
                                                        actionToTake = "approve";
                                                        actionColor = "green";
                                                        if ((kycState?.status_code as any) === orderStatusCode && kycState?.risk_code !== "high") {
                                                            actionToTakeLabel = actionToTakeLabel + " (Order & KYC)";
                                                            isOrderAndKycSameState = true;
                                                        }
                                                    }

                                                    //TODO: this needs rewriting.  I can't use two different methods of checking if the user is an approver.
                                                    else if (orderStatusCode === "processing") {
                                                        if (!customClaims["oper"]) return null;
                                                        actionToTakeLabel = "Operations Approve";
                                                        actionToTake = "operations_approve";
                                                        actionColor = "indigo";
                                                    }
                                                }
                                                console.log("Yes we can!", orderStatusCode, actionToTake, actionToTakeLabel, actionColor);

                                                let isKycInApproveAndOrderInReview = (orderStatusCode === "review" || orderStatusCode === "selling_agent_review") && kycState?.status_code === "approval";

                                                let disableOrderRejectAction = orderStatusCode === "rejected";
                                                const requiresUnitsEntry = order.type === "redemption" && order.units === 0;
                                                // let disableKycRejectAction = !kycState || kycState?.status_code === "rejected";
                                                // let disableRejectButton = disableOrderRejectAction && disableKycRejectAction;

                                                //make sure reviewer is not the same as approver

                                                // let approveButtonDisabled = kycCompleted === false;

                                                // if (actionToTake === "approve") {
                                                //     //loop through actionsAfterRejection
                                                //     for (let i = 0; i < actionsAfterRejection.length; i++) {
                                                //         if (actionsAfterRejection[i].id === userData.user?.uid) {
                                                //             // approveButtonDisabled = true;
                                                //             break;
                                                //         }
                                                //     }
                                                // }


                                                const orderNeedsKYC = !orderSkipsKYC;
                                                // KYC completion is required only if the order needs KYC and
                                                // KYC is neither complete nor in the KYC-approval/order-review case.
                                                const kycCompletionRequired =
                                                    orderNeedsKYC &&
                                                    (!kycCompleted && !isKycInApproveAndOrderInReview);
                                                const approvalDisableReasons: string[] = [];
                                                console.log("orderNeedsKYC", orderNeedsKYC);
                                                console.log("kycCompleted", kycCompleted);
                                                console.log("isKycInApproveAndOrderInReview", isKycInApproveAndOrderInReview);
                                                if (kycCompletionRequired && !isOrderAndKycSameState && !isWaitingKFHApprove) {
                                                    if (!kycData?.id) {
                                                        approvalDisableReasons.push("This order does not have a linked KYC yet.");
                                                    } else if (!kycState?.status_code) {
                                                        approvalDisableReasons.push("The linked KYC status has not loaded yet.");
                                                    } else {
                                                        approvalDisableReasons.push(`The linked KYC must be completed first. Current status: ${kycState.status ?? kycState.status_code}.`);
                                                    }
                                                }
                                                if ((orderStatusCode === "review" || orderStatusCode === "selling_agent_review" || orderStatusCode === "approval") && !allFilesTagged) {
                                                    if (orderFileTagStatus.error) {
                                                        approvalDisableReasons.push(`Order file tags could not be verified: ${orderFileTagStatus.error}`);
                                                    } else if (orderFileTagStatus.untaggedFiles.length > 0) {
                                                        approvalDisableReasons.push(`These order files are missing tags: ${orderFileTagStatus.untaggedFiles.join(", ")}`);
                                                    } else {
                                                        approvalDisableReasons.push("Order files are missing required tags.");
                                                    }
                                                }
                                                if ((actionToTake === "review" || actionToTake === "selling_agent_review") && requiresUnitsEntry) {
                                                    approvalDisableReasons.push("Enter a non-zero unit count before reviewing this redemption order.");
                                                }
                                                if ((actionToTake === "review" || actionToTake === "selling_agent_review") && order.ibanVerified === false) {
                                                    approvalDisableReasons.push(order.iban
                                                        ? `The IBAN ${order.iban} has not been verified yet. Admin or Client Relations must confirm it from the Bank Account Information panel before review.`
                                                        : "This order has an unverified IBAN. Admin or Client Relations must confirm it from the Bank Account Information panel before review.");
                                                }
                                                // approving the order also approves the KYC, which is HR only for employees
                                                if (actionToTake === "approve" && !orderSkipsKYC && isOrderAndKycSameState && customerFullData?.employee && !userClaims.hr) {
                                                    approvalDisableReasons.push("This customer is an employee: HR must approve the KYC first.");
                                                }
                                                if (actionToTake === "review" && isSubscription && !order.transferDate) {
                                                    approvalDisableReasons.push("Set a Transfer Date before reviewing this subscription order.");
                                                }
                                                const isActionDisabled = approvalDisableReasons.length > 0;
                                                console.log(`(!${kycCompleted} && !${isOrderAndKycSameState} && !${isKycInApproveAndOrderInReview}) || ((${orderStatusCode} === "review" || orderStatusCode === "selling_agent_review" || orderStatusCode === "approval") && !${allFilesTagged}) || ((${actionToTake} === "review" || actionToTake === "selling_agent_review") && ${requiresUnitsEntry})`)
                                                console.log("DISABLED=====>", isActionDisabled, approvalDisableReasons);
                                                return <Stack gap="xs">
                                                    <Group>


                                                        {actionToTake &&
                                                            <Button

                                                                disabled={isActionDisabled}
                                                                color={actionColor}
                                                                type="button" name="approve" onClick={async () => {


                                                                    setConfirmDialog({
                                                                        title: "Confirm",
                                                                        action: actionToTakeLabel,
                                                                        description: `${actionToTakeLabel} ${order.customerObj?.name_en}'s order?`,
                                                                        buttonColor: actionColor,
                                                                        callback: async () => {

                                                                            //The action needs Microzift's accessToken so I can verify groups from the server side.
                                                                            let token = await userData.getAzureADToken!(userData);

                                                                            if (!token && !userClaims?.kfh_rm_approver) {
                                                                                throw new FirebaseError("no_microsoft_token", "No Microsoft token.  Try refreshing");
                                                                            }
                                                                            if (!orderSkipsKYC) {

                                                                                if (isOrderAndKycSameState) {
                                                                                    const resKYC: any = await kycAction({
                                                                                        action: actionToTake!,
                                                                                        kycID: kycData?.id,
                                                                                        customerID: customerFullData.id,
                                                                                        token: token || "",
                                                                                    });
                                                                                    console.log(resKYC);
                                                                                }

                                                                            }


                                                                            await orderAction({ action: actionToTake as ActionType, orderID: order.id, customerID: customerRef.id, token: token || "" });
                                                                            setRefreshing(true);
                                                                            await orderRefresh({ orderID: order.id! });
                                                                            setRefreshing(false);
                                                                            console.warn("Order refreshed!");
                                                                        }
                                                                    })
                                                                }}>
                                                                {actionToTakeLabel}
                                                            </Button>
                                                        }

                                                        {/* <Menu shadow="md" width={200} trigger="click-hover">
                                                    <Menu.Target>
                                                        <Button disabled={disableRejectButton} rightSection={<IconMenu2 style={{ width: rem(14), height: rem(14) }} />} color="red">Reject</Button>
                                                    </Menu.Target>

                                                    <Menu.Dropdown>
                                                        <Menu.Item disabled={disableOrderRejectAction} onClick={async () => {
                                                            console.log("Rejecting Order!!!");
                                                            setIsRejectingOrder(true);
                                                            setRejectionOpened(true)
                                                        }} >
                                                            Reject Order
                                                        </Menu.Item>
                                                        <Menu.Item disabled={disableKycRejectAction} onClick={async () => {
                                                            console.log("Rejecting KYC!!!");
                                                            setIsRejectingOrder(false);
                                                            setRejectionOpened(true)
                                                        }} >
                                                            Reject KYC
                                                        </Menu.Item>

                                                    </Menu.Dropdown>
                                                </Menu> */}
                                                        {(orderStatusCode !== "rejected" && !(userClaims.kfh_rm)) && (
                                                            <CustomRejectionModal
                                                                onSubmit={async (values: RejectionFormValues) => {
                                                                    console.log("Rejecting Order!!!");
                                                                    setIsRejectingOrder(true);
                                                                    await handleOrderRejection(values);
                                                                }}
                                                                enableSendToAgent={order?.fund?.require_selling_agent_review}
                                                                title="Reject Order"
                                                                submitButtonText="Reject"
                                                                submitButtonColor="red"
                                                                triggerButtonText="Reject"
                                                                triggerButtonColor="red"
                                                                triggerButtonDisabled={disableOrderRejectAction}
                                                                showSMSOptions={true}
                                                                showUpdateLinkOptions={true}
                                                            />
                                                        )}

                                                    </Group>
                                                    {actionToTake && isActionDisabled && (
                                                        <Alert color="yellow" variant="light" icon={<IconAlertCircle size={16} />} maw={520}>
                                                            <Stack gap={4}>
                                                                <Text size="sm" fw={500}>Action unavailable</Text>
                                                                {approvalDisableReasons.map((reason, index) => (
                                                                    <Text key={`${actionToTake}-${index}`} size="sm">
                                                                        {reason}
                                                                    </Text>
                                                                ))}
                                                            </Stack>
                                                        </Alert>
                                                    )}
                                                </Stack>
                                            }
                                        }
                                    </ConfigContext.Consumer>
                                </Grid.Col>
                            }

                            {(((orderStatusCode === OrderStatusCode.commitment && ((customClaims.kfh_rm && orderCreatedByMe) || customClaims.kfh_oper === true || customClaims.admin))) || (orderStatusCode === OrderStatusCode.waiting_certified_rm && !order.manual && currentRmCertified)) &&

                                <Grid.Col span={4}>


                                    <Button type="button" name="send_sms" loading={draftActionLoading} onClick={async () => {
                                        setDraftActionLoading(true);


                                        const sendOrderContractMessage = httpsCallable<SendOrderSMSRequest, BaseResult>(functions, "sendOrderContractMessage");


                                        //generate a doc ID
                                        const docID = doc(collection(db, "sms")).id;
                                        setSMSDocID(docID);
                                        //set type to submit because we want the user to create an entirely new KYC
                                        await sendOrderContractMessage({
                                            order: order,
                                            token: await userData.getAzureADToken!(userData),
                                            smsDocID: docID,
                                            senderID: "KFHC-FUNDS",
                                            type: useWhatsapp ? "whatsapp" : "sms"
                                        });

                                        setDraftActionLoading(false);

                                        //call function to send SMS
                                    }}>
                                        {currentRmCertified ? "Send Order SMS" : "Submit as Referral"}
                                    </Button>
                                    {/* {((userClaims.admin || userClaims.cr || userClaims.kfh_oper || userClaims.kfh_rm) && currentRmCertified) && <Checkbox
                                        checked={useWhatsapp}
                                        label="send through whatsapp"
                                        onChange={(e) => {
                                            setSMSDocID(undefined);
                                            setUseWhatsapp(e.target.checked)


                                        }}
                                    />} */}



                                </Grid.Col>


                            }

                            {(((orderStatusCode === OrderStatusCode.waiting_certified_rm && order.manual && currentRmCertified))) &&

                                <Grid.Col span={4}>


                                    <Button type="button" name="send_sms" loading={draftActionLoading} onClick={async () => {
                                        try {
                                            setDraftActionLoading(true);


                                            const transferOrderToCertifiedRM = httpsCallable<GeneralOrderRequest, BaseResult>(functions, "transferOrderToCertifiedRM");


                                            //set type to submit because we want the user to create an entirely new KYC
                                            await transferOrderToCertifiedRM({
                                                orderId: order.id,
                                                // token: await userData.getAzureADToken!(userData),
                                                // smsDocID: docID,
                                                // senderID: "KFHC-FUNDS",
                                                // type: useWhatsapp ? "whatsapp" : "sms"
                                            });

                                            setDraftActionLoading(false);
                                            setIsError(false);
                                            setMsg("Order Transferred Successfully");
                                        } catch (error: any) {
                                            setIsError(true);
                                            console.log(error);
                                            setMsg(error.message);
                                        }


                                        //call function to send SMS
                                    }}>
                                        Review and Transfer Order to Me
                                    </Button>
                                    {/* {(userClaims.admin || userClaims.cr || userClaims.kfh_oper || userClaims.kfh_rm) && <Checkbox
                                        checked={useWhatsapp}
                                        label="send through whatsapp"
                                        onChange={(e) => {
                                            setSMSDocID(undefined);
                                            setUseWhatsapp(e.target.checked)


                                        }}
                                    />} */}



                                </Grid.Col>


                            }


                            {orderStatusCode === OrderStatusCode.signature_verification && (() => {
                                const envelope = order.docusignData;
                                const orderSegment = order.segment ?? order.customerObj?.segment ?? order.rm?.segment;
                                const sameSegmentOperations = customClaims.kfh_oper === true && !!orderSegment && !!customClaims.segment
                                    && `${customClaims.segment}`.trim().toLowerCase() === `${orderSegment}`.trim().toLowerCase();
                                const canVerifySignature = customClaims.admin === true || customClaims.cram === true || customClaims.cr === true || sameSegmentOperations;
                                const runSignatureAction = async (action: "verify_signature" | "reject_signature") => {
                                    setSignatureActionLoading(true);
                                    try {
                                        const token = await userData.getAzureADToken?.(userData).catch(() => undefined);
                                        await orderAction({ action, orderID: order.id, customerID: customerRef.id, token: token || "", comments: signatureRejectComments || undefined });
                                        if (action === "reject_signature") {
                                            if (order.kyc_id) {
                                                // Same as a CR rejection: needs_update on the existing KYC + an update link the
                                                // client re-signs through DocuSign, so the SAME KYC is updated and re-reviewed.
                                                await contractKYCUpdate({
                                                    action: "reject_signature",
                                                    kycID: order.kyc_id,
                                                    customerID: customerRef.id,
                                                    selectedPages: [...ALWAYS_SELECTED_PAGES],
                                                    comments: signatureRejectComments,
                                                    token: token || "",
                                                    sendSMS: false,
                                                    usePACI: false,
                                                    linkInfo: { updateType: "needs_update" },
                                                });
                                            } else {
                                                // no KYC on the order yet: fresh DocuSign contract link + WhatsApp to the client
                                                await createContractLink({ productRef: `orders/${order.id}`, customerID: customerRef.id, token: token || "", signingMethod: "docusign" });
                                            }
                                        }
                                        setRefreshing(true);
                                        await orderRefresh({ orderID: order.id! });
                                        setRefreshing(false);
                                        setSignatureRejectComments("");
                                        notifications.show({ title: "Done", message: action === "verify_signature" ? "DocuSign signature confirmed" : "Signature rejected and a new DocuSign link was sent to the client", color: "green" });
                                    } catch (e: any) {
                                        notifications.show({ title: "Error", message: e?.message ?? "Action failed", color: "red" });
                                    }
                                    setSignatureActionLoading(false);
                                };
                                return <Grid.Col span={12}>
                                    <Paper withBorder p="md" radius="md">
                                        <Stack gap="xs">
                                            <Title order={5}>DocuSign signature verification</Title>
                                            <Text size="sm">
                                                This client has no Kuwait Civil ID, so the contract was signed through DocuSign instead of PACI.
                                                Operations must confirm the signature is genuine before the order continues. The sealed contract and certificate of completion are in the order files.
                                            </Text>
                                            {envelope && <Text size="sm" c="dimmed">
                                                Envelope {envelope.envelopeId} · signer {envelope.signerName ?? "-"} ({envelope.signerEmail ?? envelope.signerPhone ?? "-"})
                                                {envelope.completedAt?.toDate ? ` · completed ${envelope.completedAt.toDate().toLocaleString("en-GB")}` : ""}
                                            </Text>}
                                            {canVerifySignature ? <>
                                                <Textarea
                                                    label="Rejection reason (required only when rejecting)"
                                                    placeholder="e.g. signature does not match the passport"
                                                    value={signatureRejectComments}
                                                    onChange={(e) => setSignatureRejectComments(e.currentTarget.value)}
                                                    autosize minRows={2}
                                                />
                                                <Group>
                                                    <Button color="green" loading={signatureActionLoading} onClick={() => setConfirmDialog({
                                                        title: "Confirm signature",
                                                        action: "Confirm",
                                                        description: `Confirm that ${order.customerObj?.name_en}'s DocuSign signature is genuine?`,
                                                        buttonColor: "green",
                                                        callback: () => runSignatureAction("verify_signature"),
                                                    })}>
                                                        Confirm signature
                                                    </Button>
                                                    <Button color="red" variant="outline" loading={signatureActionLoading} disabled={!signatureRejectComments.trim()} onClick={() => setConfirmDialog({
                                                        title: "Reject signature",
                                                        action: "Reject & resend",
                                                        description: `Reject the signature and send ${order.customerObj?.name_en} a new DocuSign contract?`,
                                                        buttonColor: "red",
                                                        callback: () => runSignatureAction("reject_signature"),
                                                    })}>
                                                        Reject & request new DocuSign signature
                                                    </Button>
                                                </Group>
                                            </> : <Text size="sm" c="dimmed">
                                                Waiting for KFH operations of the "{orderSegment ?? "unknown"}" segment (or KFH Capital CR/admin) to verify the signature.
                                            </Text>}
                                        </Stack>
                                    </Paper>
                                </Grid.Col>;
                            })()}

                            {orderStatusCode === "need_signature" &&

                                <Grid.Col span={12}>
                                    <Grid>
                                        <Grid.Col span={2}>
                                            <Button type="button" name="send_sms" loading={draftActionLoading} onClick={async () => {
                                                setDraftActionLoading(true);


                                                const sendOrderContractMessage = httpsCallable<SendOrderSMSRequest, BaseResult>(functions, "sendOrderContractMessage");


                                                //generate a doc ID
                                                const docID = doc(collection(db, "sms")).id;
                                                setSMSDocID(docID);

                                                //set type to submit because we want the user to create an entirely new KYC
                                                await sendOrderContractMessage({
                                                    order: order,
                                                    token: await userData.getAzureADToken!(userData),
                                                    smsDocID: docID,
                                                    senderID: "KFHC-FUNDS",
                                                    type: useWhatsapp ? "whatsapp" : "sms"
                                                });
                                                setDraftActionLoading(false);
                                                //call function to send SMS
                                            }}>
                                                Re-send Order SMS
                                            </Button>
                                        </Grid.Col>

                                        <Grid.Col span={6}>
                                            {(SMSDocID) &&

                                                <MessagesSent docID={SMSDocID} handleFailedMessages={() => {

                                                    const handleOrderSMS = async () => {

                                                        const sendOrderContractMessage = httpsCallable<SendOrderSMSRequest, BaseResult>(functions, "sendOrderContractMessage");


                                                        //generate a doc ID
                                                        const docID = doc(collection(db, "sms")).id;
                                                        setSMSDocID(docID);

                                                        //set type to submit because we want the user to create an entirely new KYC
                                                        await sendOrderContractMessage({
                                                            order: order!,
                                                            senderID: "KFHC-FUNDS",
                                                            smsDocID: docID,
                                                            token: await userData.getAzureADToken!(userData),
                                                        });
                                                    }
                                                    handleOrderSMS();
                                                }} />

                                            }
                                        </Grid.Col>
                                    </Grid>


                                </Grid.Col>
                            }

                            {((orderStatusCode === "need_signature" || orderStatusCode === "need_form" || (orderStatusCode === "manual") || orderStatusCode === "commitment") || ((customClaims.kfh_oper === true || customClaims.admin))) &&

                                <Grid.Col span={12}>
                                    {deleteButton}
                                </Grid.Col>


                            }


                        </Grid>



                    </Accordion.Panel>
                </Accordion.Item>

            </Accordion >
            <Modal
                size={"xl"}
                opened={changeRmOpen}
                onClose={() => setChangeRmOpen(false)}
                title="Change Order RM"
            >
                <ChangeRmModalContent
                    onClose={() => {
                        setChangeRmOpen(false);
                    }}
                    orderId={order.id ?? ""}
                    type='primary'
                />

            </Modal>
            <Modal
                size={"xl"}
                opened={changeReferredByRmOpen}
                onClose={() => setChangeReferredByRmOpen(false)}
                title="Change Order Referred by RM"
            >
                <ChangeRmModalContent
                    onClose={() => {
                        setChangeReferredByRmOpen(false);
                    }}
                    orderId={order.id ?? ""}
                    type='referred'
                />

            </Modal>


            {
                msg != null &&   //love my check if it's an error or not.  Please don't do this, it's just a proof of concept page.
                <Alert color={isError ? "red" : "green"}>
                    {msg}
                </Alert>
            }

        </ >

    );

}


interface EditTransferAmountProps {
    order: Order;
}

const BLOCK_UPDATE_AMOUNT_STATUS = ['done', 'processing'];

export function EditTransferAmount({ order }: EditTransferAmountProps): JSX.Element | null {
    const userData = useContext(MyUserDataContext);
    const userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};

    const isSubscription = order.type === "subscription";

    const isAllowUpdate = !!(userClaims?.["admin"] || userClaims?.["cr"]);

    const canEdit = isAllowUpdate
        && !BLOCK_UPDATE_AMOUNT_STATUS.includes(order.tags?.orderStatus?.code ?? '')
        && !(isSubscription && order.tags?.paid?.code === 'paid' && (order.payment_confirmations ?? []).length === 0);

    if (!canEdit) return null;

    return (
        <ActionIcon
            variant="white"
            aria-label={isSubscription ? "Edit transfer amount" : "Edit units"}
            onClick={() => {
                modals.open({
                    title: isSubscription ? 'Edit Transfer Amount' : 'Edit Units',
                    children: <EditTransferAmountForm order={order} />,
                });
            }}
        >
            <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
        </ActionIcon>
    );
}

/** Modal body: amount/units + mandatory reason, submits via updateOrderAmount callable. */
function EditTransferAmountForm({ order }: EditTransferAmountProps): JSX.Element {
    const isSubscription = order.type === "subscription";

    const [amount, setAmount] = useState<number | string>(
        (isSubscription ? order.transferAmount : order.units) ?? 0
    );
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    const functions = useFunctions();
    const updateOrderAmount = useMemo(
        () => httpsCallable<UpdateOrderAmountRequest, AddOrderResult>(functions, 'updateOrderAmount'),
        [functions]
    );


    const numAmount = Number(amount);

    // Subscription: nav × min_units, plus fees and overhead.
    // Redemption: fund minimum only — the portal cannot see customer holdings,
    //             so the holdings-based rules are enforced server-side.
    const minAmount = useMemo(() => {
        if (!isSubscription) return order.fund?.minimum_redemption ?? 0;
        const base = (order.fund?.nav_per_unit ?? 0) * (order.fund?.min_units ?? 0);
        const withFees = base + base * ((order.fund?.subscription_fees_percent ?? 0) / 100);
        return withFees * (1 + (order.fund?.overhead_percent ?? 0) / 100);
    }, [isSubscription, order.fund]);

    const amountError = useMemo((): string | null => {
        if (!amount || Number.isNaN(numAmount) || numAmount <= 0) {
            return isSubscription ? 'Enter a valid amount' : 'Enter a valid number of units';
        }

        if (!Number.isInteger(numAmount)) {
            return isSubscription ? 'Amount must be a whole number' : 'Units must be a whole number';
        }
        if (minAmount > 0 && numAmount < minAmount) {
            return isSubscription
                ? `Amount must be at least ${minAmount.toFixed(3)} ${order.fund?.currency ?? ''}`
                : `Units must be at least ${minAmount}`;
        }
        const current = (isSubscription ? order.transferAmount : order.units) ?? 0;
        if (numAmount === current) {
            return isSubscription ? 'Amount is unchanged' : 'Units are unchanged';
        }
        if (isSubscription) {
            const hasPayments = (order.payment_confirmations ?? []).length > 0;
            const alreadyPaid = order.paidAmount ?? order.transferAmount ?? 0;
            if (hasPayments && alreadyPaid > numAmount) {
                return `The paid amount cannot be decreased (${alreadyPaid} ${order.fund?.currency ?? ''})`;
            }
        }
        return null;
    }, [amount, numAmount, isSubscription, minAmount, order]);

    const [touched, setTouched] = useState(false);
    const displayAmountError = touched ? amountError : null;

    const reasonError = !reason.trim()
        ? 'Please enter why you are performing an update'
        : null;

    const handleSubmit = async (): Promise<void> => {
        if (amountError || reasonError) return;
        setLoading(true);
        try {
            /// Update transferAmount and estimated_units (re-calculated from the new transferAmount and the fund's nav_per_unit) in a single transaction.
            await updateOrderAmount({
                orderId: order.id!,
                amountOrQuantity: numAmount,
                customerID: order.customerObj?.id,
                reason: reason.trim(),
            });

            notifications.show({
                message: isSubscription ? 'Amount updated' : 'Units updated',
                color: 'green',
            });
            modals.closeAll();
        } catch (err) {
            notifications.show({
                message: (err as Error).message || 'Failed to update',
                color: 'red',
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Stack gap="md">
            <NumberInput
                value={amount}
                onChange={(val) => { setAmount(val); setTouched(true); }}
                thousandSeparator
                suffix={isSubscription ? ' ' + order.fund.currency : ' units'}
                min={0}
                allowDecimal={false}
                error={displayAmountError}
                description={minAmount > 0
                    ? (isSubscription
                        ? `Minimum Amount: ${minAmount.toFixed(3)}`
                        : `Minimum Units: ${minAmount}`)
                    : undefined}
                disabled={loading}
            />

            <TextInput
                label="Reason for edit"
                value={reason}
                onChange={(e) => setReason(e.currentTarget.value)}
                maxLength={500}
                error={reason.length > 0 ? reasonError : undefined}
                disabled={loading}
                required
            />

            <Group grow>
                <Button
                    onClick={handleSubmit}
                    loading={loading}
                    disabled={!!amountError || !!reasonError}
                >
                    Submit
                </Button>
                <Button variant="outline" color="red" onClick={() => modals.closeAll()} disabled={loading}>
                    Cancel
                </Button>
            </Group>
        </Stack>
    );
}
